export const contentFrench = {
  code: "FR",
  labels: {
    // App Digital Admin
    digitalAdmin: "Digital Admin",
    digitalAdminApp: "App Digital Admin",
    digitalAdminPro: "Digital Admin Pro",
    digitalAdminSarl: "Digital Admin SARL",
    copilotTitle: "Digital Copilot",
    copilotComingSoon: "Votre assistant IA arrive bientôt",
    copilotOpen: "Ouvrir le Copilot",
    copilotClose: "Fermer le Copilot",
    copilotPlaceholder: "Posez une question a votre assistant IA",
    copilotInputPlaceholder: "Ecrivez votre message...",
    copilotSend: "Envoyer",
    copilotConnected: "Connecte",
    copilotConnecting: "Connexion...",
    copilotDisconnected: "Deconnecte",
    copilotConnectionLost: "Connexion perdue",
    copilotReconnect: "Reconnecter",
    copilotToolRunning: "Recherche en cours",
    copilotActionProposed: "Action proposee",
    copilotConfirm: "Confirmer",
    copilotReject: "Rejeter",
    copilotConfirming: "Confirmation...",
    copilotRejecting: "Rejet...",
    copilotActionBlockInput: "Confirmez ou rejetez l'action proposee pour continuer",
    copilotActionHint: "Confirmez, rejetez, ou ecrivez une correction",
    copilotActionCreateContact: "Creation d'un contact",
    copilotActionCreateInvoice: "Creation d'une facture client",
    copilotActionCreateQuote: "Creation d'un devis",
    copilotActionCreateOrder: "Creation d'une commande client",
    copilotActionCreateProviderInvoice: "Creation d'une facture fournisseur",
    copilotActionCreateProviderOrder: "Creation d'une commande fournisseur",
    copilotActionCreateExpense: "Creation d'une depense",
    copilotActionCreateAccountingEntry: "Creation d'une ecriture comptable",
    copilotResultContactCreated: "Contact cree",
    copilotResultInvoiceCreated: "Facture client creee",
    copilotResultQuoteCreated: "Devis cree",
    copilotResultOrderCreated: "Commande client creee",
    copilotResultProviderInvoiceCreated: "Facture fournisseur creee",
    copilotResultProviderOrderCreated: "Commande fournisseur creee",
    copilotResultExpenseCreated: "Depense creee",
    copilotResultAccountingEntryCreated: "Ecriture comptable creee",
    copilotResultGeneric: "Action effectuee",
    copilotResultFailed: "L'action a echoue",
    copilotDiscussDocument: "Discuter avec le Copilot",
    copilotDocumentAttached: "Document joint",
    copilotDetachDocument: "Detacher",
    copilotViewPiece: "Voir la piece",
    copilotAttachDocument: "Joindre un document",
    copilotSearchExisting: "Chercher un existant",
    copilotUploadNew: "Televerser",
    copilotSearchPlaceholder: "Rechercher par nom...",
    copilotUploading: "Televersement...",
    copilotUploadError: "Echec du televersement",
    copilotNoDocuments: "Aucun document",
    uploadingFile: "Televersement en cours...",
    uploadProgress: "Progression du televersement",
    zipExtractionStarted: "Extraction ZIP lancee",
    zipExtractionInProgress: "Votre fichier ZIP est en cours d'extraction. Les documents apparaitront sous peu.",
    uploadFailed: "Echec du televersement",
    uploadTooLarge: "Le fichier depasse la taille maximale autorisee",
    copilotOnline: "En ligne",
    copilotYou: "Vous",
    copilotHistory: "Historique",
    copilotNewConversation: "Nouvelle conversation",
    copilotNoThreads: "Aucune conversation",
    copilotActionRejected: "Action rejetee",
    copilotActionFailedPast: "Action echouee",
    copilotLoadingMessages: "Chargement des messages...",
    copilotSuggestCreateExpense: "Créer une dépense",
    copilotSuggestCreateProviderInvoice: "Créer une facture fournisseur",
    copilotSuggestMsgCreateExpense: "Crée une dépense à partir du document joint.",
    copilotSuggestMsgCreateProviderInvoice: "Crée une facture fournisseur à partir du document joint.",
    copilotActionStartBatch: "Traitement par lot",
    copilotBatchConfirmText: "Traiter automatiquement tous les documents en attente. Le copilote analysera et créera les écritures correspondantes.",
    copilotBatchMilestone: "Traitement par lot",
    copilotSuggestProcessDocuments: "Traiter mes documents",
    copilotSuggestMsgProcessDocuments: "Traite automatiquement tous mes documents en attente.",
    viewDocument: "Voir le document",
    welcomeToDigitalAdmin: "Bienvenue dans Digital Admin",
    purchasePro: "Acheter Digital Admin Pro",
    signIn: "Se connecter à Digital Admin",

    // Words sentences
    about: "À propos",
    successful: "Avec succès",
    error: "Erreur",
    accountSettings: "Paramètres du compte",
    actions: "Actions",
    additional: "Supplémentaire",
    address: "Adresse",
    administrativeArea: "Canton",
    amount: "Montant",
    sum: "Somme",
    amountTotal: "Montant total",
    apply: "Appliquer",
    approved: "Approuvé",
    ascending: "Ascendant",
    addContact: "Ajouter un contact",
    addContent: "Ajouter du contenu",
    addSignature: "Ajouter une signature",
    avatar: "Avatar",
    back: "Retour",
    bban: "BBAN",
    bicSwift: "BIC/SWIFT",
    bimester: "Bimestre",
    calculatedValuesAreReferential: "Les valeurs calculées sont indicatives",
    cancel: "Annuler",
    canceled: "Annulé",
    city: "Ville",
    comment: "Commentaire",
    completed: "Terminé",
    companyContact: "Contact de l'entreprise",
    content: "Contenu",
    registerNumber: "Numéro d'enregistrement",
    concerning: "Concernant",
    contactInformation: "Informations de contact",
    continue: "Continuer",
    country: "Pays",
    create: "Créer",
    createdDate: "Date de création",
    currency: "Devise",
    customer: "Client",
    date: "Date",
    day: "Jour",
    days: "Jours",
    default: "Par défaut",
    delete: "Supprimer",
    descending: "Descendant",
    description: "Description",
    detail: "Détail",
    details: "Détails",
    discard: "Ignorer",
    doNotGroup: "Ne pas regrouper",
    edit: "Éditer",
    email: "E-mail",
    end: "Fin",
    endDate: "Date de fin",
    excel: "Excel",
    export: "Exporter",
    filter: "Filtre",
    filterOptions: "Options de filtre",
    firstName: "Prénom",
    group: "Groupe",
    halfYear: "Demi-année",
    iban: "IBAN",
    identity: "Identité",
    inProgress: "En cours",
    justNow: "À l’instant",
    lastDay: "Dernier jour",
    lastName: "Nom de famille",
    legalInformation: "Informations légales",
    list: "Liste",
    location: "Emplacement",
    menu: "Menu",
    message: "Message",
    messages: "Messages",
    archived: "Archivé",
    read: "Lire",
    unread: "Ne pas lire",
    archive: "Archiver",
    noNumber: "Sans numéro",
    noMatchingRecordsFound: "Aucun enregistrement correspondant trouvé",
    month: "Mois",
    months: "Mois",
    number: "Numéro",
    sortAlphabetically: "Trier par ordre alphabétique",
    pages: "Pages",
    pdf: "PDF",
    pending: "En attente",
    person: "Personne",
    phone: "Téléphone",
    phoneNumber: "Numéro de téléphone",
    priceGross: "Prix brut",
    priceNet: "Prix net",
    priceTotal: "Prix total",
    product: "Produit",
    products: "Produits",
    qrIban: "QR-IBAN",
    quantity: "Quantité",
    stockLimitReached: "Limite de stock atteinte",
    lowStockWarning: "Avertissement de stock faible",
    accepted: "Accepté",
    declined: "Refusé",
    rejected: "Rejeté",
    sent: "Envoyé",
    remove: "Supprimer",
    removeReference: "Supprimer la référence",
    removeContent: "Supprimer le contenu",
    removeSignature: "Supprimer la signature",
    removeRequirement: "Supprimer le bloc",
    removeVoucher: "Supprimer le reçu",
    requirement: "Bloc",
    requirements: "Blocs",
    reset: "Réinitialiser",
    saveChanges: "Enregistrer les modifications",
    searchResults: "Résultats de recherche",
    selectExportFormat: "Sélectionner le format d'exportation",
    send: "Envoyer",
    service: "Service",
    services: "Services",
    appService: "Service de l'application",
    appServices: "Services de l'application",
    signature: "Signature",
    signatures: "Signatures",
    start: "Début",
    startDate: "Date de début",
    status: "Statut",
    street: "Rue",
    subTotal: "Sous-total",
    support: "Support",
    symbol: "Symbole",
    tax: "Taxe",
    taxSale: "Taxe de vente",
    taxPurchase: "Taxe d'achat",
    taxRate: "Taux d'impôt",
    taxTotal: "Total des impôts",
    trimester: "Trimestre",
    total: "Total",
    totalAmount: "Montant total",
    top: "Top",
    type: "Type",
    timeInterval: "Intervalle de temps",
    interval: "Intervalle",
    unitMeasure: "Unité de mesure",
    unitPrice: "Prix unitaire",
    update: "Mettre à jour",
    validity: "Validité",
    value: "Valeur",
    vatNumber: "Numéro de VAT/IDE",
    contactCode: "Code contact",
    webSite: "Site internet",
    week: "Semaine",
    weeks: "Semaines",
    view: "Voir",
    yes: "Oui",
    zipCode: "Code postal",
    gross: "Brut",
    net: "Net",
    rebate: "Remise",
    rebateTotal: "Total de la remise",
    selectOptionAddAmountPercentageDesired: "Sélectionnez une option et ajoutez le montant ou pourcentage souhaité",
    changeImage: "Changer l'image",
    changeLogo: "Changer le logo",
    exportError: "Erreur lors de l'exportation",
    failedToLoadTheScript: "Échec du chargement du script",
    identificationNumberForACompany: "Numéro d'identification d'une entreprise souhaitant effectuer des opérations au niveau européen",
    internationalBankAccountNumberIban: "Numéro de compte bancaire international (IBAN)",
    listOfCompaniesIHaveAccess: "Liste des entreprises auxquelles j'ai accès",
    noRecordsFound: "Aucun enregistrement trouvé",
    noResultsFound: "Aucun résultat trouvé",
    companyNotSubjectToVat: "Aucun décompte TVA",
    companyNotSubjectToVatDescription: "Cette société n'est pas assujettie à la TVA. Aucune période de décompte n'est disponible.",
    removeImage: "Supprimer l'image",
    selectTheTypeOfContact: "Sélectionnez le type de contact que vous souhaitez créer",
    specifyTheUniqueUUID: "Spécifiez l'UUID unique d'un utilisateur ou d'une entreprise",
    theDefaultBankAccountIsTheCompanys: "Le compte de trésorerie par défaut est celui de l'entreprise",
    theDefaultCurrencyIsTheCompanys: "La devise par défaut est celle de l'entreprise",
    theDefaultShapeOrVersionOfAQrInvoiceToDownloadIsTheClients:
      "La forme ou version par défaut d'une facture QR à télécharger est celle du client",
    theDefaultLanguageToDownloadIsTheClients: "La langue par défaut pour le téléchargement est celle du client",
    youMustAcceptTheTermsAndConditions: "Vous devez accepter les termes et conditions",
    acceptingInvitationToAccessCompany: "Acceptation de l'invitation pour accéder à l'entreprise",
    verificationYourAccount: "Vérification de votre compte",
    addCompany: "Ajouter une entreprise",
    allInLicense: "Licence complète",
    buyNow: "Acheter maintenant",
    comingSoon: "Bientôt disponible",
    licenseTerms: "Conditions de licence",
    pageNotFound: "Page non trouvée",
    viewInvitations: "Voir les invitations",
    purchase: "Acheter",
    reload: "Recharger",
    systemError: "Erreur système",
    dashboard: "Dashboard",
    abbreviation: "Abréviation",
    amountPurchases: "Montant des achats",
    amountSales: "Montant des ventes",
    best: "Meilleur",
    companyInsight: "Aperçu de l'entreprise",
    comparativeInterval: "Intervalle de comparaison",
    comparisonIncomeAndExpenses: "Comparaison des revenus & dépenses",
    customerPayments: "Paiements du client",
    customRange: "Plage personnalisée",
    debtPercent: "Dette(%)",
    distributionOfQuotes: "Répartition des devis selon leur état",
    distributionOfOrders: "Répartition des commandes selon leur état",
    expirationDate: "Date d'expiration",
    creationDate: "Date d'création",
    invoicesStillToBePaid: "Factures en attente de paiement",
    invoicesStillToBePaidByTheCustomer: "Factures en attente de paiement par le client",
    invoicesWithMoreDebt: "Factures avec plus de dette",
    ordersByState: "Commandes par état",
    ordersToBilled: "Commandes à facturer",
    paidPercent: "Payé(%)",
    percentage: "Pourcentage",
    quotesByState: "Devis par état",
    quotesAccepted: "Devis acceptés",
    quotesApproved: "Devis approuvés",
    quotesToExpire: "Devis à expirer",
    retailAnalysisSample: "Échantillon d'analyse du commerce de détail",
    representationOfSalesAndPurchases: "Représentation des ventes et achats d'une entreprise par mois sur un an",
    salesVsPurchases: "Ventes vs Achats",
    thisBimester: "Ce bimestre",
    thisTrimester: "Ce trimestre",
    thisHalfYear: "Ce semestre",
    thisMonth: "Ce mois-ci",
    thisWeek: "Cette semaine",
    thisYear: "Cette année",
    today: "Aujourd'hui",
    turnout: "Montant des factures",
    viewAll: "Voir tout",
    worst: "Pire",
    yesterday: "Hier",
    fixedAmount: "Montant fixe",
    discount: "Remise",
    account: "Compte",
    changeEmail: "Changer l'e-mail",
    changePassword: "Changer le mot de passe",
    confirmNewPassword: "Confirmer le nouveau mot de passe",
    currentPassword: "Mot de passe actuel",
    emailAddress: "Adresse e-mail",
    enterNewEmailAddress: "Saisissez une nouvelle adresse e-mail",
    fullName: "Nom complet",
    newPassword: "Nouveau mot de passe",
    pleaseCheckYourEmailInbox: "Veuillez vérifier votre boîte de réception",
    profileCompleation: "Finalisation du profil",
    profileDetails: "Détails du profil",
    signInMethod: "Méthode de connexion",
    updateEmail: "Mettre à jour l'e-mail",
    updatePassword: "Mettre à jour le mot de passe",
    updateUser: "Mettre à jour l'utilisateur",
    validateAccount: "Valider le compte",
    viewUser: "Voir l'utilisateur",
    user: "Utilisateur",
    users: "Utilisateurs",
    confirmPassword: "Confirmer le mot de passe",
    createAnAccount: "Créer un compte",
    enterYourEmailToResetYourPassword: "Saisissez votre e-mail pour réinitialiser votre mot de passe",
    goToLoginPage: "Aller à la page de connexion",
    goToPreviousPage: "Aller à la page précédente",
    language: "Langue",
    languages: "Langues",
    myProfile: "Mon profil",
    notVerified: "Non vérifié",
    password: "Mot de passe",
    resetPassword: "Réinitialiser le mot de passe",
    signInHere: "Connectez-vous ici",
    signOut: "Se déconnecter",
    submit: "Soumettre",
    userProfile: "Profil utilisateur",
    use8OrMoreCharacters:
      "Utilisez 8 caractères ou plus avec une combinaison de lettres (minuscules et majuscules), de chiffres et de symboles",
    verified: "Vérifié",
    welcome: "Bienvenue",
    company: "Entreprise",
    companies: "Entreprises",
    current: "Actuel",
    addDeadlinePaymentParameter: "Ajouter un paramètre de paiement de date limite",
    addFeatureParameter: "Ajouter un paramètre de fonctionnalité",
    addImage: "Ajouter image",
    addTax: "Ajouter taxe",
    addDeadline: "Ajouter date limite",
    addFeature: "Ajouter fonctionnalité",
    addTaxRateParameter: "Ajouter un paramètre de taux de taxe",
    addUnit: "Ajouter unité",
    addUnitMeasureParameter: "Ajouter un paramètre d'unité de mesure",
    advanceSettings: "Paramètres avancés",
    aNewCompanyWillBeCreated: "Une nouvelle entreprise sera créée à partir des données saisies",
    browseUsers: "Parcourir les utilisateurs",
    companyAddress: "Adresse de l'entreprise",
    companyAdvanceSettings: "Paramètres avancés de l'entreprise",
    companyDownloadSettings: "Paramètres de téléchargement de l'entreprise",
    companyAccountingSettings: "Configuration de la comptabilité de l'entreprise",
    companyGeneralSettings: "Configuration des paramètres généraux de l'entreprise",
    companyInformationSettingGeneral: "Paramétrage des informations générales de l'entreprise",
    companyIdentity: "Identité de l'entreprise",
    companyLogo: "Logo de l'entreprise",
    companyName: "Nom de l'entreprise",
    legalForm: "Forme juridique",
    legalFormSarl: "Sàrl",
    legalFormSa: "SA",
    legalFormRi: "Raison individuelle",
    legalFormSnc: "SNC",
    legalFormCooperative: "Société coopérative",
    legalFormAssociation: "Association",
    legalFormFondation: "Fondation",
    legalFormAutre: "Autre",
    createCompany: "Créer entreprise",
    createAndSave: "Créer & Enregistrer",
    newCompany: "Nouvelle entreprise",
    designOfDocumentToDownloadQuotesAndInvoices: "Conception du document pour télécharger les devis, commandes et factures",
    downloadSettings: "Paramètres de téléchargement",
    dueDates: "Dates d'échéance pour le paiement d'une facture",
    editCompany: "Modifier l'entreprise",
    free: "Gratuit",
    generalSettings: "Paramètres généraux",
    helpPage: "Page d'aide",
    image: "Image",
    inviteAccessCompany: "Inviter à accéder à l’entreprise",
    legal: "Légal",
    listUsers: "Liste des utilisateurs",
    logo: "Logo",
    name: "Nom",
    new: "Nouveau",
    noResultFound: "Aucun résultat trouvé",
    overview: "Résumé",
    accountingSettings: "Paramètres de comptabilité",
    pleaseTryAgainWithADifferentQuery: "Veuillez réessayer avec une requête différente",
    predefinedTaxesFees: "Taxes et frais prédéfinis",
    predefinedValues: "Valeurs prédéfinies",
    freeInput: "Saisie libre",
    inputMethod: "Méthode de saisie",
    private: "Privé",
    removeLogo: "Supprimer le logo",
    selectModel: "Sélectionner un modèle",
    selectAndSaveDesiredLayoutToDownload:
      "Sélectionnez et enregistrez la mise en page souhaitée pour télécharger le devis, la commande et la facture",
    selectAndSaveOneToFourDesiredColors:
      "Sélectionnez et enregistrez de une à quatre couleurs souhaitées pour la mise en page des devis, commandes et factures",
    sendInvitation: "Envoyer une invitation",
    settings: "Paramètres",
    taxValue: "Valeur fiscale",
    templateColors: "Couleurs du modèle",
    templateModel: "Modèle de modèle",
    unitsOfMeasure: "Unités de mesure d'un service ou d'un produit",
    characteristicsForServiceProduct: "Caractéristiques d'un service ou d'un produit",
    uuidCode: "Code UUID",
    uuidCompany: "UUID de l'entreprise",
    uuidOrName: "UUID/Nom",
    usersWhoAreSubscribed: "Utilisateurs abonnés ayant accès à l'entreprise",
    viewCompany: "Voir l'entreprise",
    viewMoreUsers: "Voir plus d'utilisateurs",
    treasury: "Trésorerie",
    treasuryAccount: "Compte de trésorerie",
    treasuryCashAccount: "Compte de trésorerie espèces",
    treasuryCardAccount: "Compte de trésorerie carte",
    noCashTreasuryAccounts: "Aucun compte de trésorerie espèces disponible",
    noCardTreasuryAccounts: "Aucun compte de trésorerie carte disponible",
    conceptAccount: "Compte conceptuel",
    treasuryAccounts: "Comptes de trésorerie",
    codeOfBelongingToABankingOrganization: "Code d'appartenance à une organisation bancaire",
    createNewTreasuryAccount: "Créer un nouveau compte de trésorerie",
    createTreasuryAccount: "Créer un compte de trésorerie",
    listTreasuryAccounts: "Liste des comptes de trésorerie",
    listBookingJournals: "Liste des journaux comptables",
    listAccountingAccounts: "Lister des comptes comptables",
    viewBookingJournal: "Voir le journal comptable",
    membership: "Adhésion",
    nameOfAccount: "Nom du compte",
    contactUs: "Contactez-nous",
    typeOfTreasuryAccount: "Type de compte de trésorerie",
    updateTreasuryAccountData: "Mettre à jour les données du compte de trésorerie",
    viewTreasuryAccountsList: "Voir la liste des comptes de trésorerie",
    notification: "Notification",
    notifications: "Notifications",
    accept: "Accepter",
    accessToCompany: "Accès à l'entreprise",
    activities: "Activités",
    answers: "Réponses",
    close: "Fermer",
    companyInvitations: "Invitations d'entreprise",
    hasReceivedANotification: "Vous avez reçu une notification",
    hasReceivedAQuote: "Vous avez reçu un devis",
    hasReceivedAnInvitation: "Vous avez reçu une invitation",
    hasReceivedAnOrder: "Vous avez reçu une commande",
    newNotification: "Nouvelle notification",
    noNotifications: "Aucune notification",
    noInvitations: "Il n'y a pas d'invitations.",
    other: "Autre",
    quoteEvaluation: "Évaluation du devis",
    quoteNotification: "Notification du devis",
    approve: "Approuver",
    reject: "Rejeter",
    contact: "Contact",
    contacts: "Contacts",
    basicBankAccountNumber: "Numéro de compte bancaire de base",
    bankIdentifierCode: "Code d'identification bancaire / Société pour les télécommunications financières interbancaires mondiales",
    listContacts: "Liste des contacts",
    contactUUID: "UUID du contact",
    contactIdentity: "Identité du contact",
    contactIsNotAnAppUser: "Le contact n'est pas un utilisateur de l'application",
    contactType: "Type de contact",
    contactUuidAndType: "UUID et type de contact",
    countryContact: "Pays du contact",
    createContact: "Créer un contact",
    createNewContact: "Créer un nouveau contact",
    createContactCompanyStructure: "Créer une structure de contact de type entreprise",
    createContactPersonStructure: "Créer une structure de contact de type personne",
    deleteContact: "Supprimer le contact",
    deleteSelected: "Supprimer les éléments sélectionnés",
    definingTheIdentityOfContact: "Définition de l'identité du contact",
    definingTheInformationOfContact: "Définition des informations du contact",
    definingTheLegalInformationOfContact: "Définition des informations légales du contact",
    definingTheSettingsToDownloadQuotesAndInvoices: "Définition des paramètres pour télécharger les devis et factures",
    dragOrClickOnTheBoxToAddTheCompanyLogo: "Glissez ou cliquez sur la boîte pour ajouter le logo de l'entreprise",
    editContact: "Modifier le contact",
    enterThePostalCodeOfTheCity: "Saisissez le code postal de la ville",
    exportContacts: "Exporter les contacts",
    exportEntryContacts: "Exporter les écritures comptables",
    extendChanges: "Étendre les modifications",
    fileDownloadSettings: "Paramètres de téléchargement de fichiers",
    financialEntity: "Entité financière",
    identityOfContact: "Identité du contact",
    ifAddressDoesNotHaveANumber: "Si l'adresse n'a pas de numéro, entrez 'nn' ou 'NN'",
    whenNumberIsNotEntered: "Lorsque le numéro n'est pas saisi, il est représenté par 'NN'",
    ifNecessaryEnterSomethingReferentialRegardingAddress: "Si nécessaire, entrez une indication référentielle concernant l'adresse",
    informationOfContact: "Informations du contact",
    internationalBankAccountNumber: "Numéro de compte bancaire international",
    languageToDownload: "Langue de téléchargement du devis, de la commande ou de la facture",
    legalInformationOfContact: "Informations légales du contact",
    qrType: "Type de QR-facture",
    shapesOrVersionsOfQR: "Formes ou versions d'une QR-Facture",
    basicCurrencyCompany: "Monnaie de base de l'entreprise",
    selectCompanyAndSave: "Sélectionner une entreprise et enregistrer",
    selectCompaniesToCreateContact: "Sélectionnez les entreprises pour ajouter un nouveau contact",
    typeOfContact: "Type de contact",
    updateContactData: "Mettre à jour les données du contact",
    uuidAndType: "UUID et type",
    userUuid: "UUID de l'utilisateur",
    viewContact: "Voir le contact",
    addresses: "Adresses",
    addAddress: "Ajouter une adresse",
    editAddress: "Modifier l'adresse",
    deleteAddress: "Supprimer l'adresse",
    addressLabel: "Libellé de l'adresse",
    addressType: "Type d'adresse",
    deliveryType: "Livraison",
    billingType: "Facturation",
    otherType: "Autre",
    defaultDeliveryAddress: "Adresse de livraison par défaut",
    setAsDefault: "Définir par défaut",
    mainAddressBadge: "Principale",
    noAddressesYet: "Aucune adresse ajoutée",
    quote: "Devis",
    quotes: "Devis",
    addQuote: "Ajouter un devis",
    approveQuote: "Approuver le devis",
    companyQuoteList: "Liste des devis de l'entreprise",
    createQuote: "Créer un devis",
    newQuote: "Nouveau devis",
    dateOfDocument: "Date du document, celle-ci peut être modifiée ultérieurement",
    editQuote: "Modifier le devis",
    enterADateOrSelectADefaultPaymentDeadline: "Entrez une date ou sélectionnez une échéance de paiement par défaut",
    expired: "Expiré",
    exportQuotes: "Exporter les devis",
    generateQuote: "Générer un devis",
    inTime: "À temps",
    listQuotes: "Liste des devis",
    quoteDate: "Date du devis",
    quoteGroups: "Groupes de devis",
    quoteNumber: "Numéro de devis",
    quoteReference: "Référence du devis",
    quoteStatus: "Statut du devis",
    quoteValidity: "Validité du devis",
    rejectQuote: "Rejeter le devis",
    sendQuote: "Envoyer le devis",
    updateQuote: "Mettre à jour le devis",
    viewQuote: "Voir le devis",
    purchases: "Achats",
    sales: "Ventes",
    sale: "Vente",
    principal: "Principal",
    humanResources: "Ressources humaines",
    closingJournal: "Journal de bouclement",
    manuallyCreated: "Créé manuellement",
    expenses: "Dépenses",
    addExpense: "Ajouter dépense",
    createExpense: "Créer dépense",
    editExpense: "Modifier dépense",
    expenseDate: "Date de dépense",
    expenseGroups: "Groupes de dépenses",
    expenseNumber: "Numéro de dépense",
    expenseValidity: "Validité de la dépense",
    invalidateExpense: "Invalider dépense",
    listExpenses: "Liste des dépenses",
    removeExpense: "Supprimer dépense",
    updateExpense: "Mettre à jour dépense",
    validateExpense: "Valider dépense",
    viewExpense: "Voir dépense",
    addProviderInvoice: "Ajouter facture fournisseur",
    createProviderInvoice: "Créer facture fournisseur",
    editProviderInvoice: "Modifier facture fournisseur",
    invalidateProviderInvoice: "Invalider facture fournisseur",
    listProviderInvoices: "Liste des factures fournisseurs",
    myTreasuryAccount: "Mon compte de trésorerie",
    provider: "Fournisseur",
    providerBankAccount: "Compte bancaire du fournisseur",
    providerInvoiceDate: "Date de la facture fournisseur",
    providerInvoiceGroups: "Groupes de factures fournisseurs",
    providerInvoiceStatus: "Statut de la facture fournisseur",
    providerInvoiceValidity: "Validité de la facture fournisseur",
    providerInvoices: "Factures fournisseurs",
    providerOrderNumber: "Numéro de commande fournisseur",
    updateProviderInvoice: "Mettre à jour facture fournisseur",
    validateProviderInvoice: "Valider facture fournisseur",
    viewProviderInvoice: "Voir facture fournisseur",
    addProviderOrder: "Ajouter commande fournisseur",
    approveProviderOrder: "Approuver commande fournisseur",
    cancelProviderOrder: "Annuler commande fournisseur",
    createProviderOrder: "Créer commande fournisseur",
    editProviderOrder: "Modifier commande fournisseur",
    generateProviderInvoice: "Générer facture fournisseur",
    generateProviderOrder: "Générer commande fournisseur",
    listProviderOrders: "Liste des commandes fournisseurs",
    providerOrderDate: "Date de commande fournisseur",
    providerOrders: "Commandes fournisseurs",
    providerOrderGroups: "Groupes de commandes fournisseurs",
    providerOrderReference: "Référence de la commande fournisseur",
    providerInvoiceReference: "Référence de la facture fournisseur",
    expenseReference: "Référence de la dépense",
    providerOrderStatus: "Statut de la commande fournisseur",
    updateProviderOrder: "Mettre à jour commande fournisseur",
    viewProviderOrder: "Voir commande fournisseur",
    providerQuote: "Devis fournisseur",
    providerQuotes: "Devis fournisseurs",
    listProviderQuotes: "Liste des devis fournisseurs",
    viewProviderQuote: "Voir devis fournisseur",
    sourceQuoteNumber: "Réf. devis source",
    sourceCompany: "Entreprise émettrice",
    acceptQuote: "Accepter le devis",
    declineQuote: "Refuser le devis",
    internalNotes: "Notes internes",
    saveNotes: "Enregistrer les notes",
    providerQuoteAccepted: "Devis accepté, commande fournisseur créée",
    providerQuoteDeclined: "Devis refusé",
    confirmAcceptQuote: "Accepter ce devis ? Une commande fournisseur sera créée automatiquement.",
    confirmDeclineQuote: "Refuser ce devis ?",
    declineReasonLabel: "Motif du refus",
    declineReasonPlaceholder: "Veuillez expliquer pourquoi vous refusez ce devis...",
    declineInvoiceReasonPlaceholder: "Veuillez expliquer pourquoi vous refusez cette facture...",
    declineReasonRequired: "Un motif est requis pour refuser.",
    recipientDecision: "Décision du destinataire",
    decisionAccepted: "Accepté par le destinataire",
    decisionDeclined: "Refusé par le destinataire",
    decisionDate: "Date de la décision",
    declineReason: "Motif du refus",
    acceptanceStatus: "Statut d'acceptation",
    acceptancePending: "En attente d'acceptation",
    acceptanceNotRequired: "Non requis",
    acceptInvoice: "Accepter la facture",
    declineInvoice: "Refuser la facture",
    providerInvoiceAccepted: "Facture acceptée",
    providerInvoiceDeclined: "Facture refusée",
    confirmAcceptInvoice: "Accepter cette facture ?",
    confirmDeclineInvoice: "Refuser cette facture ?",
    seeProviderOrder: "Voir la commande fournisseur",
    addVouchers: "Ajouter justificatif(s)",
    download: "Télécharger",
    file: "Fichier",
    lastModified: "Dernière modification",
    size: "Taille",
    vouchers: "Justificatifs",
    addFiles: "Ajouter fichiers",
    attachFiles: "Joindre fichiers",
    removeAll: "Tout supprimer",
    uploadFiles: "Téléverser fichiers",
    orders: "Commandes",
    order: "Commande",
    orderEvaluation: "Évaluation de la commande",
    orderGroups: "Groupes de commandes",
    orderNotification: "Notification de commande",
    orderReference: "Référence de la commande",
    orderStatus: "Statut de la commande",
    addOrder: "Ajouter commande",
    approveOrder: "Approuver commande",
    rejectOrder: "Rejeter la commande",
    cancelOrder: "Annuler commande",
    companyListOfOrders: "Liste des commandes de l'entreprise",
    companyListOfInvoices: "Liste des factures de l'entreprise",
    companyListOfQuotes: "Liste des devis de l'entreprise",
    companyListOfProviderInvoices: "Liste des factures fournisseur",
    companyListOfProviderOrders: "Liste des commandes fournisseur",
    companyListOfProviderQuotes: "Liste des devis fournisseur",
    companyListOfExpenses: "Liste des dépenses",
    companyListOfExpenseReports: "Liste des notes de frais",
    createOrder: "Créer commande",
    delivery: "Livraison",
    deliveyAddress: "Adresse de livraison",
    deliveryNote: "Bon de livraison",
    deliveryNotes: "Bons de livraison",
    createDeliveryNote: "Créer un bon de livraison",
    noDeliveryNotesYet: "Aucun bon de livraison pour le moment",
    delivered: "Livré",
    notDelivered: "Non livré",
    deliveryDate: "Date de livraison",
    deliverAll: "Tout livrer",
    quantityToDeliver: "Qté à livrer",
    quantityOrdered: "Qté commandée",
    quantityDelivered: "Qté livrée",
    quantityRemaining: "Qté restante",
    alreadyFullyDelivered: "Déjà entièrement livré",
    quantityReceived: "Qté reçue",
    quantityToEnter: "Qté à entrer",
    allItemsReceived: "Tous les articles ont été reçus",
    selectAtLeastOneQuantity: "Veuillez sélectionner au moins une quantité à entrer",
    sendByEmail: "Envoyer par email",
    sendToCustomer: "Envoyer au client",
    personalizedMessage: "Message personnalisé",
    deliveryAddressSelection: "Sélection de l'adresse de livraison",
    mainAddress: "Adresse principale",
    manageAddresses: "Gérer les adresses",
    storageCenterSelection: "Sélection du centre de stockage",
    autoStockOut: "Sortie de stock automatique",
    quantityInStock: "Quantité en stock",
    stockAvailability: "Disponibilité du stock",
    stockWarnings: "Alertes de stock",
    deliveryProgress: "Progression de la livraison",
    deliveryComplete: "Livraison complète",
    deliveryPartial: "Livraison partielle",
    notDeliveredYet: "Pas encore livré",
    deliveryAddressLabel: "Adresse de livraison",
    sentAt: "Envoyé le",
    sentMethod: "Méthode d'envoi",
    backToOrder: "Retour à la commande",
    linesDelivered: "Lignes livrées",
    createInvoiceFromSelection: "Créer une facture à partir de la sélection",
    ordersWillBeInvoicedTogether: "commande(s) seront facturées ensemble",
    ordersSelected: "commande(s) sélectionnée(s)",
    editOrder: "Modifier commande",
    exportOrder: "Exporter commande",
    exportOrders: "Exporter commandes",
    generateInvoice: "Générer facture",
    generateOrder: "Générer commande",
    listOrders: "Liste des commandes",
    orderDate: "Date de la commande",
    orderFile: "Fichier de commande",
    orderNumber: "Numéro de commande",
    selectExportType: "Sélectionner type d'exportation",
    sendOrder: "Envoyer commande",
    thisOptionIsUniqueAndNewInvoice:
      "Cette option est unique et il n'est pas possible de créer une nouvelle facture à partir de cette commande",
    updateOrder: "Mettre à jour commande",
    viewOrder: "Voir commande",
    invoice: "Facture",
    invoices: "Factures",
    addInvoice: "Ajouter facture",
    amountDebt: "Montant dette",
    amountPaid: "Montant payé",
    companyInvoiceList: "Liste des factures de l'entreprise",
    createInvoice: "Créer facture",
    editInvoice: "Modifier facture",
    exportInvoices: "Exporter factures",
    exportProviderInvoices: "Exporter factures fournisseur",
    exportProviderOrders: "Exporter commandes fournisseur",
    exportProviderQuotes: "Exporter devis fournisseur",
    exportExpenses: "Exporter dépenses",
    exportExpenseReports: "Exporter notes de frais",
    debt: "Dette",
    fullyPaid: "Totalement payé",
    invalidInvoices: "Factures non valides",
    invalidateInvoice: "Invalider facture",
    invalidateProviderOrder: "Invalider la commande du fournisseur",
    validateProviderOrder: "Valider la commande du fournisseur",
    invoiceGroups: "Groupes de factures",
    invoiceDate: "Date de facture",
    invoiceNumber: "Numéro de facture",
    invoiceStatus: "Statut de la facture",
    invoiceValidity: "Validité de la facture",
    listInvoices: "Liste des factures",
    notPayed: "Non payé",
    partiallyPaid: "Partiellement payé",
    payed: "Payé",
    thisInvoiceHasNoPayments: "Cette facture n'a pas de paiements",
    updateInvoice: "Mettre à jour facture",
    validated: "Validée",
    validateInvoice: "Valider facture",
    viewInvoice: "Voir facture",
    youWillBeAbleToUndoThisAction: "Vous pourrez annuler cette action",
    payment: "Paiement",
    payments: "Paiements",
    amountToPay: "Montant à payer",
    createNewPayment: "Créer un nouveau paiement",
    deleteSomePayment: "Supprimer un paiement",
    doNotDeletePayments: "Ne supprimer aucun paiement",
    makePayment: "Effectuer paiement",
    method: "Méthode",
    paymentDate: "Date de paiement",
    paymentMethod: "Méthode de paiement",
    save: "Enregistrer",
    sourceOfIncome: "Source de revenus",
    accountingAccountProductService: "Comptabiliser le produit ou le service",
    sourceTheAmount: "Source où le montant d'argent de la transaction est déposé ou retiré",
    sourceTheAmountEntered: "Source où le montant d'argent pour la transaction est saisi",
    sourceTheAmountWithdrawn: "Source à partir de laquelle le montant de la transaction est retiré",
    cash: "Espèces",
    card: "Carte",
    payPal: "PayPal",
    transfer: "Virement",
    mobile: "Mobile",
    thisOptionIncludeTaxPrice: "Cette option inclut la taxe dans le prix indiqué",
    thisOptionNotIncludeTaxPrice: "Cette option n'inclut pas la taxe dans le prix indiqué",
    addOrRemoveContactCompanies: "Ajouter ou supprimer des contacts d'entreprises",
    notifyMe: "Me notifier",
    background: "Arrière-plan",
    inventory: "Inventaire",
    viewProduct: "Voir produit",
    storageCenter: "Centre de stockage",
    listStorageCenter: "Liste des centres de stockage",
    viewStorageCenter: "Vue du centre de stockage",
    afterSalesService: "Service après-vente",
    bookingJournals: "Journaux comptables",
    appLanguage: "Langue de l'application",
    theUuidCanBeUsedToCreateNnewContact: "L'UUID peut être utilisé pour créer un nouveau contact",
    settingInformation: "Informations de configuration",
    addOrRemoveCompanies: "Ajouter/Supprimer des entreprises",
    notGrouped: "Non groupé",
    notFiltered: "Non filtré",
    orderValidity: "Validité de la commande",
    expiration: "Expiration",
    quoteExpiration: "Expiration du devis",
    orderExpiration: "Expiration de la commande",
    invoiceExpiration: "Expiration de la facture",
    discountTotal: "Remise totale",
    addService: "Ajouter service",
    addProduct: "Ajouter produit",
    noRecords: "Aucun enregistrement",
    quantityMinimumForRebate: "Quantité minimale pour remise",
    nonExistentRebateNegativePrice: "Remise inexistant pour prix négatif",
    thisOptionRebateIsFixedAmount: "Cette option indique que la remise est un montant fixe",
    thisOptionRebateIsPercentage: "Cette option indique que la remise est un pourcentage",
    thisOptionRebateIsNone: "Cette option indique qu'il n'y a pas de remise",
    totalAfterRebates: "Total après remises",
    calculator: "Calculatrice",
    enterRebate: "Saisissez le remboursement",
    reference: "Référence",
    newOrder: "Nouvelle commande",
    invoiceReference: "Référence de la facture",
    newInvoice: "Nouvelle facture",
    providerOrderValidity: "Validité de la commande fournisseur",
    expenseStatus: "Statut des dépenses",
    newProviderOrder: "Nouvelle commande fournisseur",
    newProviderInvoice: "Nouvelle facture fournisseur",
    newExpense: "Nouvelle dépense",
    viewVoucher: "Voir justificatif",
    informationAdditional: "Informations supplémentaires",
    no: "Non",
    bank: "Banque",
    fullNameBankAccountHolder: "Nom complet du titulaire du compte bancaire",
    bankAccountHolder: "Titulaire du compte bancaire",
    isNecessaryToHaveReferenceToActivateOption: "Il est nécessaire d'avoir une référence pour activer cette option",
    isNecessaryToHaveAtLeastTwoTreasuryAccountsToActivateOption:
      "Il est nécessaire d'avoir au moins deux comptes de trésorerie pour activer cette option",
    none: "Aucun",
    undefined: "Indéfini",
    colorCombinationForDesignOfDocumentToDownload: "Combinaison de couleurs pour le design du document à télécharger",
    all: "Tout",
    lettersTitlesSubtitles: "Lettres, titres, sous-titres",
    firstBar: "Première barre",
    secondBar: "Deuxième barre",
    barLetters: "Lettres de la barre",
    qrIbanAndQrReference: "QR-IBAN et QR-Référence",
    ibanAndStructuredCreditorReference: "IBAN et Référence de Créancier Structurée (SCOR)",
    ibanWithoutReference: "IBAN sans référence",
    cashAccount: "Compte en espèces",
    postalAccount: "Compte postal",
    bankAccount: "Compte bancaire",
    currentAccount: "Compte courant associé",
    listProducts: "Liste des produits",
    category: "Catégorie",
    categories: "Catégories",
    listCategories: "Liste des catégories",
    tags: "Étiquettes",
    variants: "Variantes",
    photography: "Photographie",
    reminder: "Rappel",
    reminders: "Rappels",
    paymentStatus: "Statut de paiement",
    year: "Année",
    createReminder: "Créer rappel",
    updateReminder: "Mettre à jour le rappel",
    makeCopy: "Créer copie",
    reminderTotal: "Total du rappel",
    inDispute: "En litige",
    addCategory: "Ajouter catégorie",
    addStorageCenter: "Ajouter centre de stockage",
    addBookingJournal: "Ajouter journaux comptable",
    qtyAssets: "QTY actifs",
    qtyServices: "QTY services",
    qtyProducts: "QTY produits",
    viewCategory: "Voir la catégorie",
    editCategory: "Modifier la catégorie",
    deleteCategory: "Supprimer la catégorie",
    names: "Noms",
    listCategoryItems: "Liste des éléments de la catégorie",
    editListing: "Modifier la liste",
    updateCategoryItemList: "Mettre à jour la liste des éléments de la catégorie",
    updateCategory: "Mettre à jour la catégorie",
    nameInOtherLanguages: "Nom dans d'autres langues",
    enterInLanguageWant: "Entrez la langue souhaitée",
    enterNameOfRequestedLanguages: "Entrez le nom des langues demandées",
    enterDesiredValuePressEnterAdd: "Saisissez la valeur souhaitée et appuyez sur Entrée pour l'ajouter",
    enterOrModifyInLanguage: "Entrez ou modifiez dans la langue souhaitée",
    general: "Général",
    categoryName: "Nom de la catégorie",
    categoryType: "Type de catégorie",
    createCategory: "Créer une catégorie",
    editProduct: "Modifier le produit",
    deleteProduct: "Supprimer le produit",
    productReferencePictures: "Images de référence du produit",
    code: "Code",
    sku: "SKU",
    codebar: "Code-barres",
    color: "Couleur",
    unit: "Unité",
    price: "Prix",
    priceSale: "Prix ​​de vente",
    pricePurchase: "Prix d'achat",
    fixed: "Fixé",
    productName: "Nom du produit",
    productDetails: "Détails du produit",
    advanced: "Avancé",
    addVariant: "Ajouter une variante",
    uniqueProductCodeAssignedByCompany: "Code produit unique attribué par l'entreprise",
    additionalCommentDescriptionProductVariant: "Commentaire ou description supplémentaire de la variante du produit",
    selectDiscountTypeAppliedToProduct: "Sélectionnez un type de remise à appliquer à ce produit",
    discountType: "Type de remise",
    selectDiscountTypeThatWillAppliedProduct: "Sélectionnez un type de remise à appliquer à ce produit",
    noDiscount: "Pas de remise",
    setDiscountPercentage: "Définir le pourcentage de remise",
    fixedDiscountedAmount: "Montant fixe de la remise",
    quantityMinimumDiscount: "Quantité minimale pour remise",
    createProduct: "Créer un produit",
    dropFilesHereOrClickUpload: "Déposez les fichiers ici ou cliquez pour télécharger",
    dropFileHereOrClickUpload: "Déposez le fichier ici ou cliquez pour charger",
    uploadUpToFiles: "Téléchargez jusqu'à 10 fichiers",
    success: "Succès",
    addNewProductVariant: "Ajouter une nouvelle variante de produit",
    editVariant: "Modifier la variante",
    editProductVariant: "Modifier la variante du produit",
    updateProduct: "Mettre à jour le produit",
    saveVariant: "Enregistrer la variante",
    listServices: "Liste des services",
    viewService: "Voir le service",
    editService: "Modifier le service",
    deleteService: "Supprimer le service",
    serviceReferencePictures: "Images de référence du service",
    serviceName: "Nom du service",
    serviceDetails: "Détails du service",
    createService: "Créer un service",
    updateService: "Mettre à jour le service",
    uniqueServiceCodeAssignedByCompany: "Code de service unique attribué par l'entreprise",
    selectDiscountTypeAppliedToService: "Sélectionnez un type de remise à appliquer à ce service",
    expenseAccount: "Compte de dépenses",
    vatAccount: "Compte de TVA",
    accountProduct: "Compte de produit",
    accountingAccount: "Compte comptable",
    accountingAccounts: "Comptes comptables",
    accountingAccountPurchases: "Compte comptable pour les achats",
    accountingAccountSales: "Compte comptable pour les ventes",
    addAccountingAccount: "Ajouter un compte comptable",
    rangeAllowedCodes: "Plage de codes autorisés",
    effective: "Décompte effectif",
    tdfn: "Taux de la dette fiscale nette (TDFN)",
    taf: "Taux forfaitaire (TaF)",
    vatAccountingType: "Type de décompte TVA",
    theVatRegimeCanOnlyChangedOnceAYear:
      "Le régime de TVA ne peut être modifié qu'une fois par an, juste avant le début d'une nouvelle année comptable",
    debit: "Débit",
    credit: "Crédit",
    customerReceivable: "Créance client",
    providerReceivable: "Créance fournisseur",
    vatDue: "TVA due",
    vatRecoverable: "TVA récupérable",
    declarationMethod: "Méthode de déclaration",
    onInvoicing: "Selon la facturation (à la facturation)",
    onCashing: "Selon les encaissements (à l’encaissement)",
    valid: "Valide",
    invalid: "Invalide",
    colorIsInvalid: "Couleur invalide",
    theValueIsNotAValid: "La valeur n'est pas valide",
    theValueIsNotAValidUUIDOrNameUser: "La valeur n'est pas un UUID ou un nom d'utilisateur valide",
    theValueIsAtLeast8Digits: "La valeur comporte au moins 8 chiffres",
    theValueDoesNotMatch: "La valeur ne correspond pas",
    theValueAlreadyExists: "La valeur existe déjà",
    limitFilesMaximum: "Limite de 10 fichiers maximum",
    required: "Requis",
    theValueIsRequired: "La valeur est requise",
    allValuesRequired: "Toutes les valeurs sont requises",
    colorIsRequired: "La couleur est requise",
    requirementsIsRequired: "Les blocs sont requis",
    paymentsIsRequired: "Des paiements sont requis",
    contentsToRequirementIsRequired: "Le contenu du bloc est requis",
    transaction: "Transaction",
    createNewPaymentForInvoice: "Créer un nouveau paiement pour la facture",
    createNewPaymentForProviderInvoice: "Creer un nouveau paiement pour la facture fournisseur",
    addTransaction: "Ajouter une transaction",
    accountingEntry: "Écriture comptable",
    amountAvailable: "Montant disponible",
    selectExistingTransaction: "Sélectionner une transaction existante",
    totalAmountDebt: "Montant total de la dette",
    presetCurrency: "Devise prédéfinie",
    deposit: "Dépôt",
    deposition: "Dépôt",
    depositAmount: "Montant du dépôt",
    pastTransactions: "Transactions passées",
    noPastTransactions: "Aucune transaction passée",
    selectTransaction: "Sélectionner une transaction",
    providerInvoice: "Facture du fournisseur",
    expense: "Dépense",
    enterNewTransaction: "Entrer une nouvelle transaction",
    useExistingTransaction: "Utilizes une transaction existante",
    transactionToRecordPayment: "Transaction pour pouvoir enregistrer le paiement",
    amountMoneyEnteredInTransaction: "Montant d'argent saisi dans la transaction",
    amountMoneyWithdrawnInTransaction: "Montant d'argent retiré dans la transaction",
    identifiedTransactions: "Transactions identifiées",
    unidentifiedTransactions: "Transactions non identifiées",
    totalDepositAmount: "Montant total du dépôt",
    makeCorrespondingPayment: "Effectuer le paiement correspondant",
    balance: "Solde",
    accountingEntries: "Écritures comptables",
    contactBalance: "Solde de contact",
    accountStatement: "Relevé de compte",
    accountStatements: "Relevé de comptes",
    invoiceIssuance: "Émission de la facture",
    saleIssuance: "Émission de vente",
    providerInvoiceIssuance: "Émission de la facture fournisseur",
    expenseIssuance: "Émission de la dépense",
    allocationInvoiceReminder: "Affectation pour rappel de facture",
    transactionToPostFinance: "Transaction au Compte PostFinance",
    transactionFormPostFinance: "Transaction au Compte PostFinance",
    balancePrevious: "Solde précédent",
    includeOpeningBalance: "Inclure le solde à nouveau",
    balanceFavorContact: "Solde en votre faveur",
    balanceFavorCompany: "Solde en notre faveur",
    addCredit: "Ajouter crédit",
    addDebit: "Ajouter débit",
    createClientCredit: "Nouvelle écriture au crédit",
    createClientDebit: "Nouvelle écriture au débit",
    unidentifiedTransactionToRegisterInContact: "Transaction non identifiée à enregistrer en contact",
    draft: "Brouillon",
    revertToDraft: "Passer en brouillon",
    beforeCreatingProviderInvoice: "Avant de créer une facture fournisseur",
    beforeCreatingProviderOrder: "Avant de créer une commande fournisseur",
    beforeCreatingExpense: "Avant de créer une dépense",
    viewPdf: "Voir le PDF",
    viewOriginalPdf: "Voir le PDF original",
    documentPdf: "PDF du document",
    viewReferencePdf: "Voir le PDF de référence",
    referencePdf: "PDF de référence",
    invalidFileType: "Fichier au format différent",
    fileInDifferentFormatImg: "Fichier au format différent. Types de fichiers autorisés : jpeg, jpg ou png",
    fileSizeNotAllowed: "Fichier trop gros. Taille maximale du fichier : 1 Mo",
    fileInDifferentFormatPdf: "Fichier dans un format différent. Format de fichier : pdf",
    fileIsTooBig: "Le fichier est trop volumineux. Taille maximale : 10 Mo",
    addDocument: "Ajouter document",
    validate: "Valider",
    invalidate: "Invalider",
    listing: "Listage",
    creation: "Création",
    accounting: "Comptabilité",
    generalLedger: "Grand livre",
    bookingJournal: "Journaux comptable",
    label: "Libellé",
    multipleWriting: "Écriture multiple",
    simplifiedMultipleWriting: "Écriture multiple simplifiée",
    availableAmount: "Montant disponible",
    level: "Niveau",
    coefficient: "Coefficient",
    leave: "Feuille",
    title: "Titre",
    writingSimple: "Écriture simple",
    writingMultiple: "Écriture multiple",
    writingSimplifiedMultiple: "Écriture multiple simplifiée",
    taxIncluded: "Avec TVA",
    taxExcluded: "Sans TVA",
    taxFee: "Taxe fiscale (TVA)",
    vatOptions: "Options TVA",
    interest: "Intérêt",
    penalty: "Amende",
    refund: "Remboursement",
    creditNote: "Note de crédit",
    customerInterest: "Intérêt client",
    customerPenalty: "Pénalité client",
    customerRefund: "Remboursement client émis",
    providerPayment: "Paiement émis fournisseur",
    providerCreditNote: "Avoir fournisseur émis",
    providerInterest: "Intérêt fournisseur",
    providerPenalty: "Pénalité fournisseur",
    providerRefund: "Remboursement reçu fournisseur",
    customerPayment: "Paiement reçu d’un client",
    customerCreditNote: "Avoir client émis",
    transactionType: "Type de transaction",
    resend: "Renvoyer à nouveau",
    information: "Information",
    generalInformation: "Informations générales",
    vatCalculationPeriod: "Période de calcul de la TVA",
    dependsWhetherCompanySubjectTax: "Cela dépend de l'assujettissement de l'entreprise à l'impôt",
    dependsCompanySpecialVatRegime: "Cela dépend du régime de TVA spécifique de l'entreprise",
    dependsCompanyVatCalculationPeriod: "Cela dépend de la période de calcul de la TVA de l'entreprise",
    upcomingVatStatement: "Prochain relevé de TVA",
    deadline: "Date limite",
    quarter: "Quart",
    semester: "Semestre",
    chartAccounts: "Plan comptable",
    vatStatement: "Décompte TVA",
    listVatStatements: "Liste des déclarations de TVA",
    manual: "Manuel",
    vatSettingsMap: "Carte paramètres TVA",
    listPeriodsStatement: "Liste des périodes pour la déclaration de TVA",
    vatAmount: "TVA",
    vatAmountDue: "Montant TVA due",
    regime: "Régime",
    calculation: "Calcul",
    tickets: "Tickets",
    pendingVatTickets: "Tickets TVA en attente",
    orphansOnly: "Orphelins uniquement",
    formLine: "Ligne form.",
    vatShort: "TVA",
    side: "Côté",
    accrual: "Comptabilisation",
    open: "Ouvert",
    filed: "Déposé",
    closed: "Fermé",
    listPeriodStatement: "Liste des périodes de reporting",
    exportStatementPeriod: "Exportation de la période de reporting",
    editAccountingSettings: "Modifier paramètres comptables",
    brand: "Marque",
    features: "Caractéristiques",
    createStorageCenter: "Créer un centre de stockage",
    updateStorageCenter: "Mettre à jour le centre de stockage",
    editStorageCenter: "Centre de stockage de modifications",
    addInventory: "Ajouter à l'inventaire",
    storagePurchase: "Stockage à acheter",
    operations: "Opérations",
    storageOperations: "Opérations de stockage",
    listOperationsStorageCenter: "Liste des opérations d'un centre de stockage",
    sourceLocation: "Lieu de départ",
    destinationLocation: "Lieu de destination",
    source: "Source",
    invalidated: "Invalidé",
    in: "Entrée",
    out: "Sortie",
    adjustment: "Réglage",
    stockEntry: "Entrée de stock",
    stockExit: "Sortie de stock",
    stockTransfer: "Transfert de stock",
    sourceStorageCenter: "Centre de sortie",
    destinationStorageCenter: "Centre d'entrée",
    availableStock: "Stock disponible",
    quantityToTransfer: "Quantité à transférer",
    addLine: "Ajouter une ligne",
    selectProduct: "Sélectionner un produit",
    removeLine: "Supprimer",
    providerOrder: "Commande du fournisseur",
    updatePos: "Mise à jour du point de vente",
    pos: "POS",
    listPOS: "Lister les POS",
    createPOS: "Créer un POS",
    createNewPOS: "Créer un nouveau point de vente",
    viewPOS: "Voir le POS",
    createSale: "Créer une vente",
    pointOfSale: "Point de vente",
    selectProducts: "Sélectionner des produits",
    selectedItems: "Articles sélectionnés",
    noItemsSelected: "Aucun article sélectionné",
    step1: "Étape 1",
    step2: "Étape 2",
    paymentMethods: "Moyens de paiement",
    received: "Reçu",
    totalPaid: "Total payé",
    totalCash: "Total espèces",
    totalCard: "Total carte",
    paymentCalculation: "Calcul de paiement",
    completeSale: "Finaliser la vente",
    listOfSales: "Liste des ventes",
    noTransactionsToday: "Aucune transaction aujourd'hui",
    totalTransactions: "Total des transactions",
    active: "Actif",
    inactive: "Inactif",
    startCreatingNewPOSForYourCompany: "Commencez à créer de nouveaux POS pour votre entreprise",
    add: "Ajouter",
    change: "Rendu",
    cashier: "Caissier",
    saleNumber: "Numéro de vente",
    viewSale: "Voir la vente",
    return: "Retour",
    createNewSale: "Créer une nouvelle vente",
    defaultCustomerSale: "Client par défaut d'une vente",
    heWantsAccessApplicationLink: "Il souhaite accéder à l'application via un lien",
    security: "Sécurité",
    signOutAllDevices: "Déconnectez-vous de tous les appareils",
    editDeadlinePaymentParameter: "Modifier le paramètre de délai de paiement",
    editFeatureParameter: "Modifier le paramètre de fonctionnalité",
    editMeasureUnitParameter: "Modifier le paramètre d'unité de mesure",
    addMeasureUnitParameter: "Ajouter un paramètre d'unité de mesure",
    areYouSureYouWantToDeleteThisRecord: "Êtes-vous sûr de vouloir supprimer cet enregistrement ?",
    youWontBeAbleToRevertThis: "Vous ne pourrez pas annuler cette action",
    yesDeleteIt: "Oui, supprimer",
    confirmPurchase: "Confirmer l'achat",
    confirmPurchaseDesignMessage: "Souhaitez-vous confirmer l'achat de ce design ?",
    yesPurchase: "Oui, acheter",
    companyColorSettings: "Paramètres des couleurs de l'entreprise",
    saveColors: "Enregistrer les couleurs",
    companyDesignSettings: "Paramètres de design de l'entreprise",
    currentDesign: "Design actuel",
    setAsCurrent: "Définir comme actuel",
    subjectToVat: "Assujetti à la TVA",
    companySwitchingNotAvailableInView:
      "Le changement d'entreprise n'est pas disponible dans cette vue ; il ne peut être effectué que depuis les vues générales de l'entreprise",

    // Start sentence
    selectOneOption: "Sélectionnez une des options,",
    iAgree: "J'accepte &",
    youWantToChangeOrderStatusTo: "Souhaitez-vous changer le statut de la commande en",
    createdAt: "Créé le",
    updatedAt: "Mis à jour le",
    validUntil: "Valide jusqu'au",
    clickOn: "Cliquez sur",
    thisContactWillOnlyBeRegisteredInCompany: "Ce contact sera uniquement enregistré dans l'entreprise",
    securedPaymentBy: "Paiement sécurisé par",
    anInvitationWillBeSent: "Une invitation sera envoyée pour accéder à l’entreprise",
    ifYouNeedMoreInfo: "Si vous avez besoin de plus d'informations, consultez",
    theInvitationToAccess: "L'invitation pour accéder à l'entreprise de la part de l'utilisateur",
    theQuoteThatYouSent: "Le devis que vous avez envoyé à l'entreprise",
    youHaveAlreadyEvaluatedOrder: "Vous avez déjà évalué la commande de l'entreprise",
    youHaveAlreadyEvaluatedQuote: "Vous avez déjà évalué le devis de l'entreprise",
    youHaveAlreadyRespondedTo: "Vous avez déjà répondu à",
    youHaveReceivedAQuote: "Vous avez reçu un devis de l'entreprise",
    ifYouDoNotWishToExtendContactModificationsToOtherCompanies:
      "Si vous ne souhaitez pas étendre les modifications du contact à d'autres entreprises, ne cochez rien et sélectionnez",
    youWantToChangeQuoteStatusTo: "Souhaitez-vous changer le statut du devis en",
    youWantToChangeProviderOrderStatusTo: "Souhaitez-vous changer le statut de la commande fournisseur en",
    theOrderThatYouSent: "La commande que vous avez envoyée à l'entreprise",
    youHaveReceivedAnOrder: "Vous avez reçu une commande de l'entreprise",
    theCurrentCompanyIs: "L'entreprise actuelle est",
    toCreateA: "Pour créer un(e)",
    createdBy: "Créé par",
    groupBy: "Grouper par",
    checkOrUncheck: "Cochez ou décochez les",
    ifYouWishChangeVatRegimePleaseContact: "Si vous souhaitez modifier le régime de TVA, veuillez contacter",
    ifYouInvalidateInvoice: "Si vous invalidez la facture",
    ifYouInvalidateProviderOrder: "Si vous invalidez la commande du fournisseur",
    ifYouInvalidateProvaiderInvoice: "Si vous invalidez la facture fournisseur",
    ifYouInvalidateExpense: "Si vous invalidez la dépense",
    the: "Le / La",
    planYourBusinessApplications: "Planifiez vos applications commerciales en choisissant l'une des",
    yourAccountIsNotVerified: "Votre compte n'est pas vérifié. Validez votre compte via votre adresse e-mail en cliquant sur le bouto",
    chargeFor: "Charge de",
    serverErrorOccurred: "Une erreur de serveur s’est produite",
    noResponseServer: "Aucune réponse du serveur",
    serviceTemporarilyUnavailable: "Le service est temporairement indisponible. Veuillez réessayer.",
    records: "Archives",
    invitations: "Invitations",
    consignment: "Consignation",
    consignmentReturn: "Retour de consignation",
    consignments: "Consignations",
    listConsignments: "Liste des consignations",
    commissionType: "Type de commission",
    commissionRate: "Taux de commission",
    newConsignment: "Nouvel accord",
    receiveProducts: "Réceptionner des produits",
    returnProducts: "Retourner des invendus",
    generateReport: "Générer le rapport",
    quantitySold: "Qté vendue",
    quantityReturned: "Qté retournée",
    quantityAvailable: "Qté disponible",
    quantityToReturn: "Qté à retourner",
    totalSoldValue: "Total ventes",
    commissionAmount: "Montant commission",
    amountDueToProvider: "Montant dû au fournisseur",
    closeAgreement: "Clôturer l'accord",
    consignmentAgreement: "Accord de consignation",
    fixedPrice: "Prix fixe",
    documents: "Documents",
    document: "Document",
    listDocuments: "Liste des documents",
    uploadDocument: "Télécharger un document",
    assignDocument: "Assigner un document",
    archiveDocument: "Archiver le document",
    unarchiveDocument: "Désarchiver le document",
    ignoreDocument: "Ignorer le document",
    unignoreDocument: "Réactiver le document",
    inbox: "Boîte de réception",
    archives: "Archives",
    youWantToIgnoreThisDocument: "Voulez-vous vraiment ignorer ce document ?",
    youWantToUnignoreThisDocument: "Voulez-vous vraiment réactiver ce document ?",
    youWantToArchiveThisDocument: "Voulez-vous vraiment archiver ce document ?",
    youWantToUnarchiveThisDocument: "Voulez-vous vraiment désarchiver ce document ?",
    successfullyIgnored: "Document ignoré avec succès",
    successfullyUnignored: "Document réactivé avec succès",
    successfullyArchived: "Document archivé avec succès",
    successfullyUnarchived: "Document désarchivé avec succès",
    cannotIgnoreDocument: "Impossible d'ignorer le document",
    cannotIgnoreDocumentWithAssignments: "Ce document a des affectations actives. Retirez-les avant de l'ignorer.",
    deleteDocument: "Supprimer le document",
    fileName: "Nom du fichier",
    assignedTo: "Assigné à",
    assigned: "Assigné",
    preview: "Aperçu",
    downloadFile: "Télécharger le fichier",
    upload: "Télécharger",
    assign: "Assigner",
    documentType: "Type de document",
    documentReference: "Référence du document",
    enterDocumentReference: "Entrez la référence du document",
    partiallyProcessed: "Partiellement traité",
    processed: "Traité",
    originalFile: "Fichier original",
    documentDate: "Date du document",
    uploadedOn: "Téléchargé le",
    documentDetails: "Détails du document",
    documentName: "Nom du document",
    previewNotAvailable: "Aperçu non disponible",
    documentUpdated: "Document mis à jour",
    createFromDocument: "Créer depuis ce document",
    attachExistingDocument: "Joindre un document existant",
    selectDocumentToAttach: "Sélectionner un document à joindre",
    documentAttached: "Document joint avec succès",
    noDocumentsAvailable: "Aucun document disponible",
    attach: "Joindre",
    uploadNewPdf: "Téléverser un nouveau PDF",
    removeDocument: "Retirer",
    confirmRemoveVoucher: "Retirer ce document ?",
    brands: "Marques",
    youWantToDeleteThisBrand: "Souhaitez-vous supprimer cette marque ?",
    listBrands: "Liste des marques",
    createBrand: "Créer une marque",
    searchBrand: "Rechercher une marque",
    clear: "Effacer",
    sortBy: "Trier par",
    show: "Afficher",
    perPage: "par page",
    showing: "Affichage",
    of: "de",
    nameRequired: "Name erforderlich",
    nameIsRequired: "Der Name ist erforderlich",
    updateBrand: "Marke aktualisieren",
    enterBrandName: "Markennamen eingeben",
    logoUrlHint: "Logo-URL eingeben",
    processing: "Wird verarbeitet",
    editBrand: "Marke bearbeiten",
    logoUrl: "Logo-URL",
    addBrand: "Ajouter une marque",
    selectBrand: "Sélectionner une marque",
    noBrandsAvailable: "Aucune marque disponible",

    // End sentence
    companyPleaseEvaluateQuote: ", veuillez évaluer le devis.",
    theAssociatedAccountingEntriesWillBeDeletedInvoice:
      ", les écritures comptables associées seront supprimées. Cela signifie que vous ne pourrez pas effectuer de paiements ni générer des frais de rappels liés à cette facture.",
    theAssociatedAccountingEntriesWillBeDeletedProviderInvoice:
      ", les écritures comptables associées seront supprimées. Cela signifie que vous ne pourrez pas effectuer de paiements ni générer des frais de rappels liés à cette facture fournisseur.",
    theAssociatedAccountingEntriesWillBeDeletedExpense:
      ", les écritures comptables associées seront supprimées. Cela signifie que vous ne pourrez pas effectuer de paiements ni générer des frais de rappels liés à cette dépense.",
    theAssociatedProductsWillBeRemoved:
      ", les produits associés seront supprimés. Cela signifie qu’ils ne seront pas enregistrés dans l’inventaire des centres de stockage liés à cette commande fournisseur.",
    ifYouWishToSaveTheChangesMade: "si vous souhaitez enregistrer les modifications effectuées.",
    youWantToRun: "que vous souhaitez exécuter.",
    toContinue: "pour continuer.",
    waitAMomentToVerifyYourAccess: "attendez un moment pour vérifier votre accès.",
    hasSentARequestForAccessToTheFollowingCompany: "a envoyé une demande d'accès à l'entreprise suivante, veuillez répondre.",
    ifYouWantToSaveTheNewQuote: "si vous souhaitez enregistrer le nouveau devis.",
    ifYouWantToSaveTheNewQuoteWithTheChangesMade: "si vous souhaitez enregistrer le nouveau devis avec les modifications effectuées.",
    ifYouWantToSaveTheNewInvoiceWithTheChangesMade: "si vous souhaitez enregistrer la nouvelle facture avec les modifications effectuées.",
    ifYouWantToSaveTheNewExpense: "si vous souhaitez enregistrer la nouvelle dépense.",
    ifYouWantToSaveTheNewProviderInvoice: "si vous souhaitez enregistrer la nouvelle facture fournisseur.",
    ifYouWantToSaveTheNewProviderOrder: "si vous souhaitez enregistrer la nouvelle commande fournisseur.",
    ifYouWantToSaveTheNewProviderOrderWithTheChangesMade:
      "si vous souhaitez enregistrer la nouvelle commande fournisseur avec les modifications effectuées.",
    ifYouWantToSaveTheNewProviderInvoiceWithTheChangesMade:
      "si vous souhaitez enregistrer la nouvelle facture fournisseur avec les modifications effectuées.",
    ifYouWantToSaveTheNewOrder: "si vous souhaitez enregistrer la nouvelle commande.",
    ifYouWantToSaveTheNewOrderWithTheChangesMade: "si vous souhaitez enregistrer la nouvelle commande avec les modifications effectuées.",
    companyPleaseEvaluateTheOrder: "entreprise, veuillez évaluer la commande.",
    ifYouWantToSaveTheNewInvoice: "si vous souhaitez enregistrer la nouvelle facture.",
    youWillNotBeAbleToRemoveItFromThisCompany:
      ", vous ne pourrez pas le supprimer de cette entreprise, mais vous pouvez sélectionner les autres entreprises.",
    inThisCategory: "dans cette catégorie.",
    theCompanyContainTreasutyAccount: "l'entreprise doit contenir au moins un compte de trésorerie.",
    toBeAddedInOrderToDownloadTheInvoice: "doit être ajoutée pour télécharger la facture.",

    // All sentence
    enterNewPassword: "Saisissez un nouveau mot de passe.",
    ifYouChangeYourMind: "Si vous changez d'avis, demandez à recevoir une nouvelle demande.",
    messageWillBeSentYourEmailToRecoverAccount:
      "Un message sera envoyé à votre adresse e-mail pour récupérer le compte. Veuillez vérifier votre boîte de réception. Vous serez redirigé vers la page de connexion.",
    yuouCanNowStartUsingApp:
      "Vous pouvez maintenant commencer à utiliser l'application, vous serez bientôt redirigé vers la page d'accueil.",
    newCompanyIsSelectedByDefault: "La nouvelle entreprise est sélectionnée par défaut et vous serez redirigé vers la page principale.",
    notificationWillBeDeleted: "La notification de l'invitation à accéder à l'entreprise sera supprimée.",
    theAppWillBeTranslated: "L'application sera traduite dans la langue indiquée, sauf pour les informations saisies dans les documents.",
    userWillRespondInvitation: "L'utilisateur répondra s'il accepte ou non l'invitation à accéder à l'entreprise.",
    youWillNotBeAbleToUndo: "Vous ne pourrez pas annuler cette action.",
    toValidateYourAccount: "Pour valider votre compte, un message sera envoyé à votre adresse e-mail où vous pourrez le vérifier.",
    pleaseCheckEmailToValidateAccount: "Veuillez vérifier votre e-mail, nous avons envoyé un message pour valider votre compte.",
    anEmailSentToValidateAccount: "Un e-mail vous a été envoyé pour valider votre compte.",
    validatedAccountForLoggedInUser: "Compte validé pour l'utilisateur connecté, redirection vers la page principale.",
    validatedAccountForADifferentUser:
      "Compte validé pour un utilisateur différent de celui connecté, redirection vers la page de connexion.",
    validatedVerifiedForAUserWhoHasNotLoggedIn:
      "Validation vérifiée pour un utilisateur qui ne s'est pas connecté, redirection vers la page de connexion.",
    newServicesWithinTheSameApp: "Nouveaux services au sein de la même application.",
    soonYouWillBeAbleToAccessNewFunctionalities: "Vous pourrez bientôt accéder à de nouvelles fonctionnalités dans l'application.",
    pleaseCorrectThePathOfThePageInOrderToAccess: "Corrigez le chemin de la page pour accéder à l'application.",
    pleaseTryAgainLater: "Veuillez réessayer plus tard.",
    validTokenAutomaticLoginRedirectedDashboard: "Jeton valide, connexion automatique, redirection vers le tableau de bord.",
    redirectingToLogin: "Redirection vers la page de connexion.",
    willNotBeAbleToReturnUntilYouLogin: "Vous ne pourrez pas revenir tant que vous ne vous serez pas reconnecté.",
    enterEmailWhetherBelongsRegisteredUserOrNot:
      "Saisissez l’adresse e-mail, qu’elle appartienne à un utilisateur enregistré ou non. Une notification sera envoyée pour accéder à l’application et à l’entreprise, soit dans l’application (si l’utilisateur existe), soit à l’adresse e-mail fournie.",
    theFileMustBeFormat: "Le fichier doit être au format jpeg, jpg ou png.",
    ifYouHaveAnyQuestionsContactUs: "Si vous avez des questions, vous pouvez nous contacter.",
    noNotificationsSeenYet: "Aucune notification vue pour le moment.",
    thereAreNoNotifications: "Aucune notification reçue pour l'instant.",
    invitationsHaveNotReceived: "Les invitations n'ont pas encore été reçues.",
    byDefaultValuesOfTheCompanyAreTaken: "Par défaut, les valeurs de l'entreprise sont prises.",
    selectTheOptionsThatBestConsiderWhenDownloading:
      "Sélectionnez les options que vous jugez les plus appropriées lors du téléchargement d'un devis ou d'une facture au format PDF.",
    notificationsAboutInvitationsToSubscribe: "Notifications concernant les invitations à s'abonner et à accéder à une entreprise.",
    whenCreatingAContactByUUID:
      "Lors de la création d'un contact par UUID, vous ne pourrez pas modifier certains champs en fonction du type : personne (nom, prénom et e-mail) et entreprise (nom).",
    youCanDirectlyEnterUUIDOfAUserOrCompanyToAddAsContact:
      "Vous pouvez entrer directement l'UUID d'un utilisateur ou d'une entreprise pour l'ajouter comme contact ; sinon, choisissez le type de contact que vous souhaitez créer.",
    descriptionCreateQuote: "Veuillez saisir les informations suivantes, elles sont nécessaires pour créer un nouveau devis.",
    descriptionCreateOrder: "Veuillez saisir les informations suivantes, elles sont nécessaires pour créer une nouvelle commande.",
    descriptionCreateInvoice: "Veuillez saisir les informations suivantes, elles sont nécessaires pour créer une nouvelle facture.",
    sorryLooksLikeThereAreSomeErrorstryAgain: "Désolé, il semble qu'il y ait des erreurs, veuillez réessayer.",
    sorryLooksLikeThereAreSomeErrorsTrySolve: "Désolé, il semble qu'il y ait des erreurs, essayez de les résoudre.",
    sorryThereIsNothingToAdd: "Désolé, il n'y a rien à ajouter, veuillez réessayer.",
    thankYouVeryMuchForSubscribingRedirectingToPreviousPage: "Merci beaucoup pour votre abonnement, redirection vers la page précédente.",
    actionCompletedReturningToPage: "Action terminée, retour à la page.",
    actionCompletedRedirectingToPage: "Action terminée, redirection vers la page.",
    pleaseModifyAddOrDeleteFieldsFromQuote: "Veuillez modifier, ajouter et/ou supprimer les champs souhaités du devis.",
    thisOptionIsUniqueAndNewOrderCannotBeCreatedFromThisQuote:
      "Cette option est unique et une nouvelle commande ne peut pas être créée à partir de ce devis.",
    descriptionCreateProviderInvoice:
      "Veuillez saisir les informations suivantes, elles sont nécessaires pour créer une nouvelle facture fournisseur.",
    pleaseModifyAddOrDeleteFieldsFromProviderInvoice:
      "Veuillez modifier, ajouter et/ou supprimer les champs souhaités de la facture fournisseur.",
    pleaseModifyAddOrDeleteFieldsFromExpense: "Veuillez modifier, ajouter et/ou supprimer les champs souhaités de la dépense.",
    descriptionCreateExpense: "Veuillez saisir les informations suivantes, elles sont nécessaires pour créer une nouvelle dépense.",
    descriptionCreateProviderOrder:
      "Veuillez saisir les informations suivantes, elles sont nécessaires pour créer une nouvelle commande fournisseur.",
    pleaseModifyAddOrDeleteFieldsFromProviderOrder:
      "Veuillez modifier, ajouter et/ou supprimer les champs souhaités de la commande fournisseur.",
    fileFormatMaximum10MBPerFile: "Le format de fichier est '.pdf' et la taille maximale est de 10 Mo.",
    someOfTheUploadedFilesDoNotMeetTheRequiredCharacteristics:
      "Certains des fichiers téléchargés ne respectent pas les caractéristiques requises.",
    pleaseModifyAddOrDeleteFieldsFromOrder: "Veuillez modifier, ajouter et/ou supprimer les champs souhaités de la commande.",
    pleaseModifyAddOrDeleteFieldsFromInvoice: "Veuillez modifier, ajouter et/ou supprimer les champs souhaités de la facture.",
    thisAmountCanNotBeGreater: "Ce montant ne peut pas être supérieur à la dette totale de la facture.",
    amountMinOfDueAndTransaction: "Minimum entre le montant dû de la facture et le montant de la transaction.",
    toCreateAnDocument: "Pour créer un document, l'entreprise doit contenir au moins un compte de trésorerie.",
    newContactWwillAddedToCompanyAndSelectDefault:
      "Un nouveau contact sera ajouté à l'entreprise et sélectionné par défaut, retour à la page.",
    youHaveSuccessfullyResetYourPassword:
      "Vous avez réinitialisé votre mot de passe avec succès, vous pouvez maintenant vous reconnecter. Redirection vers la page de connexion.",
    ifNoAmountIsEnteredTheValueWillBeZero: "Si aucun montant n'est saisi, la valeur sera de 0.",
    ifYouWishYouCanAssignNameInLanguagesNecessary:
      "Si vous le souhaitez, vous pouvez attribuer le nom dans les langues que vous jugez nécessaires.",
    productNameRequiredAndRecommendedUnique: "Un nom de produit est requis et il est recommandé qu'il soit unique.",
    addProductToCategory: "Ajouter un produit à une catégorie.",
    addTagsToProduct: "Ajouter des étiquettes au produit, elles peuvent être facultatives.",
    setProductMediaGallery: "Configurer la galerie multimédia du produit.",
    serviceNameRequiredAndRecommendedUnique: "Un nom de service est requis et il est recommandé qu'il soit unique.",
    addServiceToCategory: "Ajouter un service à une catégorie.",
    addTagsToService: "Ajouter des étiquettes au service, elles peuvent être facultatives.",
    setServiceMediaGallery: "Configurer la galerie multimédia du service.",
    aCategoryContainServicesProducts: "Une catégorie peut contenir à la fois des services et des produits.",
    ifSoAdditionalInformationRequired: "Si oui, des informations supplémentaires seront requises.",
    toPerformAnySubsequentActionWithInvoice:
      "Pour effectuer toute action ultérieure avec la facture, il sera nécessaire de la valider à nouveau en spécifiant les comptes comptables correspondants à chaque produit et/ou service associé.",
    toPerformAnySubsequentActionWithProviderInvoice:
      "Pour effectuer toute action ultérieure avec la facture fournisseur, il sera nécessaire de la valider à nouveau en spécifiant les comptes comptables correspondants à chaque produit et/ou service associé.",
    toPerformAnySubsequentActionWithExpense:
      "Pour effectuer toute action ultérieure avec la dépense, il sera nécessaire de la valider à nouveau en spécifiant les comptes comptables correspondants à chaque produit et/ou service associé.",
    toPerformAnyFurtherActionProviderOrder:
      "Pour effectuer toute autre action concernant la commande du fournisseur, il sera nécessaire d'en créer une copie.",
    validatingInvoiceSystemWillCreateToFollowingAccountingEntries:
      "Lors de la validation de la facture, le système créera les écritures comptables suivantes. Veuillez confirmer les comptes comptables de chaque service ou produit de la facture.",
    validatingProviderInvoiceSystemWillCreateToFollowingAccountingEntries:
      "Lors de la validation de la facture fournisseur, le système créera les écritures comptables suivantes. Veuillez confirmer les comptes comptables de chaque service ou produit de la facture fournisseur.",
    validatingExpenseSystemWillCreateToFollowingAccountingEntries:
      "Lors de la validation de la dépense, le système créera les écritures comptables suivantes. Veuillez confirmer les comptes comptables de chaque service ou produit de la dépense.",
    allowedFileTypes: "Types de fichiers autorisés : png, jpg, jpeg.",
    whenYouUploadPdfFilesTheyArePlacedReferenceSupplieIinvoiceCreationform:
      "Lorsque vous téléchargez un ou plusieurs fichiers PDF, ils sont placés comme référence dans le formulaire de création de facture du fournisseur.",
    someFilesIncorrectlyFormattedAndTooLarge: "Certains fichiers sont mal formatés et d’autres sont trop volumineux.",
    someFilesIncorrectlyFormatted: "Certains fichiers sont mal formatés.",
    someFilesTooLarge: "Certains fichiers sont trop volumineux.",
    searchSelectContact: "Rechercher et sélectionner un contact.",
    accountingBookWithTotalAccountingEntriesCompany: "Livre comptable avec l'ensemble des écritures comptables de l'entreprise.",
    byDefaultSimpleWriting: "Par défaut, une écriture simple est créée.",
    selectAllPossibleOptions: "Sélectionnez toutes les options possibles.",
    newManualAccountingBookCreated: "Un nouveau livre comptable manuel sera créé.",
    selectOptionToEnableForm: "Sélectionnez une option pour activer le formulaire.",
    selectApplicableScheme: "Sélectionnez le régime applicable.",
    enterApplicableVatRate: "Saisissez le taux de TVA applicable.",
    theSystemAddingFollowingProductsToCompanyInventoryProviderOrder:
      "Le système ajoute les produits suivants à l'inventaire de l'entreprise. Veuillez confirmer les centres de stockage de chaque produit sur la commande fournisseur.",
    theSystemAddingFollowingProductsToCompanyInventoryProviderInvoice:
      "Le système ajoute les produits suivants à l'inventaire de l'entreprise. Veuillez confirmer les centres de stockage de chaque produit sur la commande fournisseur.",
    addPaymentUsingCashOrCardOrDeposit: "Ajoutez un paiement en espèces, par carte ou par dépôt.",

    // Lowercase sentences
    yearl: "année",
    years: "années",
    hour: "heure",
    hours: "heures",
    minute: "minute",
    minutes: "minutes",
    items: "éléments",
    groups: "groupes",
    selected: "sélectionné",
    accountNeedsA: "le compte a besoin d'un",
    options: "options",
    with: "avec",
    bestCustomers: "meilleurs clients",
    byRecentUpdates: "par mises à jour récentes",
    byTimeRange: "par plage de temps",
    template: "modèle",
    evaluated: "évalué",
    noMailFound: "aucun e-mail trouvé",
    report: "rapport",
    reports: "rapports",
    requestOnAccess: "demande d'accès à l'entreprise, votre réponse a été",
    userHasBeen: "a été",
    yourAnswerHasBeen: ", votre réponse a été",
    toUser: "à l'utilisateur",
    hasBeen: "a été",
    byYear: "par année",
    or: "ou",
    quotesToExpireThisMonth: "les devis expireront ce mois-ci",
    worstCustomers: "pires clients",
    button: "bouton",
    termsAndConditions: "termes et conditions",
    and: "et",
    ourServicesOrRequesting: "nos services ou en demandant un nouveau",
    toAddOrRemoveCategory: "que vous souhaitez ajouter ou supprimer de la catégorie",
    orCall: "ou appelez le numéro",
    invoicesNotYetPaid: "factures non encore payées",
    collections: "collections",
    from: "de",

    // Interrogative sentences
    isDeliveryAddressTheSameAsCustomersAddress: "L'adresse de livraison est-elle la même que l'adresse du client ?",
    youWantLogOut: "Voulez-vous vous déconnecter ?",
    doesItTakeALongTimeToLoadTheApp: "L'application met-elle beaucoup de temps à charger ?",
    alreadyHaveAnCccount: "Vous avez déjà un compte ?",
    forgotPassword: "Mot de passe oublié ?",
    newHere: "Nouveau ici ?",
    doYouWantToSendInvitation: "Souhaitez-vous envoyer une invitation pour accéder à l'entreprise ?",
    selectThisTreasuryAccountAsTheMainOne: "Sélectionner ce compte de trésorerie comme principal ?",
    youWantToDeleteThisTreasuryAccount: "Voulez-vous supprimer ce compte de trésorerie ?",
    youWantToSelectThisTreasuryAccountAsPrimary: "Voulez-vous sélectionner ce compte de trésorerie comme principal ?",
    wantToExtendChangesToOtherCompanies: "Voulez-vous étendre les modifications à d'autres entreprises ?",
    youWantToDeleteThisContact: "Voulez-vous supprimer ce contact ?",
    youWantToDeleteSelectedContacts: "Voulez-vous supprimer les contacts sélectionnés ?",
    youWantSendQuote: "Voulez-vous envoyer le devis au client ?",
    youWantToChangeQuoteStatusRejected: "Voulez-vous changer le statut du devis à refusé ?",
    youWantToGenerateAnOrderFromThisQuote: "Voulez-vous générer une commande à partir de ce devis ?",
    youWantToChangeStatusTheExpense: "Voulez-vous changer le statut de la dépense ?",
    youWantToDeleteThisDocument: "Voulez-vous supprimer ce document ?",
    youWantToRevertThisDocumentToDraft: "Voulez-vous passer ce document en brouillon ?",
    youWantToDeleteThisExpense: "Voulez-vous supprimer cette dépense ?",
    youWantToChangeStatusTheProviderInvoice: "Voulez-vous changer le statut de la facture du fournisseur ?",
    youWantToGenerateAProviderInvoiceFromThisProviderOrder:
      "Voulez-vous générer une facture fournisseur à partir de cette commande fournisseur ?",
    youWantToChangeOrderStatusToCanceled: "Voulez-vous changer le statut de la commande à annulé ?",
    youWantToGenerateAnInvoiceFromThisOrder: "Voulez-vous générer une facture à partir de cette commande ?",
    youWantToSendTheOrderToCustomer: "Voulez-vous envoyer la commande au client ?",
    youWantToCreateDeliveryNote: "Voulez-vous créer un bon de livraison ?",
    aFullDeliveryNoteWillBeCreated: "Un bon de livraison complet sera créé pour tous les articles de cette commande",
    youWantToSendDeliveryNote: "Voulez-vous envoyer ce bon de livraison ?",
    youWantToDeleteThisPayment: "Voulez-vous supprimer ce paiement ?",
    youWantToChangeStatusTheInvoice: "Voulez-vous changer le statut de la facture ?",
    isCompanyOwnerOfBankAccount: "L'entreprise est-elle titulaire du compte bancaire ?",
    useReferenceWithinQR: "Utiliser une référence dans le QR ?",
    youWantDeleteProduct: "Voulez-vous supprimer ce produit ?",
    youWantDeleteSelectedProducts: "Voulez-vous supprimer les produits sélectionnés ?",
    youWantToDeleteThisReminder: "Voulez-vous supprimer ce rappel ?",
    youWantToDeleteThisCategory: "Voulez-vous supprimer cette catégorie ?",
    youWantToDeleteTheStorageCenter: "Voulez-vous supprimer le centre de stockage ?",
    youWantToDeleteSelectedCategories: "Voulez-vous supprimer les catégories sélectionnées ?",
    youWantToDeleteTheStorageCenters: "Voulez-vous supprimer les centres de stockage ?",
    youWantDeleteService: "Voulez-vous supprimer ce service ?",
    youWantDeleteSelectedServices: "Voulez-vous supprimer les services sélectionnés ?",
    isCompanySubjectVat: "L'entreprise est-elle assujettie à la TVA ?",
    wouldYouLikeUploadPdfFilesToRegistrationNnewInvoice:
      "Souhaitez-vous télécharger un ou plusieurs fichiers PDF pour faciliter l'enregistrement d'une nouvelle facture ?",
    howWouldLikeDeclareVat: "Comment souhaitez-vous déclarer la TVA ?",
    youWantToDeleteThisPOS: "Voulez-vous supprimer ce POS ?",
    doYouWantJoinNewCompany: "Souhaitez-vous rejoindre la nouvelle entreprise ?",
    youWantToSendByEmail: "Voulez-vous envoyer ce document par email ?",
    youWantToSendToCustomer: "Voulez-vous envoyer ceci au client ?",
    youWantToDeleteThisAddress: "Voulez-vous supprimer cette adresse ?",
    youWantToSetDefaultAddress: "Voulez-vous définir cette adresse comme adresse par défaut ?",
    youWantToRejectQuote: "Voulez-vous rejeter ce devis ?",
    youWantToRejectOrder: "Voulez-vous rejeter cette commande ?",

    // Exclamative sentences
    important: "Important !",
    exclamError: "Erreur ! ",
    networkError: "Erreur réseau !",
    httpError: "Erreur HTTP !",
    yourSessionHasBeenClosed: "Votre session a été fermée, veuillez vous reconnecter !",
    yourSessionHasExpired: "Votre session a expiré, veuillez vous reconnecter !",
    accountNotValidated: "Compte non encore validé !",
    newRegisteredUser: "Nouvel utilisateur enregistré !",
    moneyBackGuarantee: "Garantie de remboursement à 100 % !",
    somethingWentWrong: "Une erreur est survenue !",
    thePageYouLookedNotFound: "La page que vous recherchez est introuvable !",
    yourSessionIsActiveCongratulations: "Votre session est active, félicitations !",
    weNeedYourAttention: "Votre attention est requise !",
    yourAreDone: "C'est terminé !",
    startCreatingNewTreasuryAccountsForYourCompany:
      "Commencez à créer de nouveaux comptes de trésorerie pour votre entreprise, c'est très important pour le fonctionnement de l'application !",
    itNotChangeCompany: "Il n'est pas possible de changer d'entreprise !",
    weAreWorkingFeature: "Nous travaillons sur cette fonctionnalité. Elle sera disponible très prochainement !",
    processOfCreatingANewInvoiceCompleted: "Processus de création d'une nouvelle facture terminé !",
    processOfUpdatingAInvoiceCompleted: "Processus de mise à jour d'une facture terminé !",
    thereAreNoTreasuryAccounts: "Aucun compte bancaire disponible !",
    incorrectFiles: "Fichiers incorrects !",
    startAddingNewElementsToThisCategory: "Commencez à ajouter de nouveaux éléments à cette catégorie !",
    accountingAccountAlreadySelected: "Compte comptable déjà sélectionné, veuillez en choisir un autre !",
    servicesProductsWithTaxGreaterThanZero: "Services ou produits avec une taxe supérieure à zéro !",
    youHaveSuccessfullySignedOut: "Vous vous êtes déconnecté avec succès !",
    selectContactViewTheirAccountStatement: "Sélectionnez un contact pour consulter son relevé de compte !",
    processOfCreatingANewOrderCompleted: "Processus de création d'une nouvelle commande terminé !",
    processOfUpdatingAnOrderCompleted: "Processus de mise à jour d'une commande terminé.",
    processOfCreatingQuoteCompleted: "Processus de création d'un nouveau devis terminé !",
    processOfCreatingAQuoteFromAnotherQuoteCompleted: "Processus de création d'un devis à partir d'un autre devis terminé !",
    processOfCreatingAOrderFromAnotherOrderCompleted: "Processus de création d'une commande à partir d'une autre commande terminé !",
    processOfCreatingAInvoiceFromAnotherInvoiceCompleted: "Processus de création d'une facture à partir d'une autre facture terminé !",
    processOfUpdatingAQuoteCompleted: "Processus de mise à jour d'un devis terminé !",
    processOfCreatingANewExpenseCompleted: "Processus de création d'une nouvelle dépense terminé !",
    processOfUpdatingAnExpenseCompleted: "Processus de mise à jour d'une dépense terminé !",
    processOfCreatingANewProviderInvoiceCompleted: "Processus de création d'une nouvelle facture fournisseur terminé !",
    processOfUpdatingAProviderInvoiceCompleted: "Processus de mise à jour d'une facture fournisseur terminé !",
    processOfCreatedAProviderOrderCompleted: "Processus de création d'une commande fournisseur terminé !",
    processOfCreatedAProviderInvoiceCompleted: "Processus de création d'une facture fournisseur terminé !",
    processOfCreatingANewProviderOrderCompleted: "Processus de création d'une nouvelle commande fournisseur terminé !",
    processOfUpdatingAProviderOrderCompleted: "Processus de mise à jour d'une commande fournisseur terminé !",
    successfullyCreatedAccountingAccount: "Compte comptable créé avec succès !",
    successfullyCreatedCategory: "Catégorie créée avec succès !",
    successfullyUpdatedCategory: "Catégorie mise à jour avec succès !",
    successfullyInvitationSent: "Invitation envoyée avec succès !",
    successfullyInvitationCancel: "Invitation annulée avec succès !",
    successfullyCreatedContact: "Contact créé avec succès !",
    successfullyUpdatedContact: "Contact mis à jour avec succès !",
    successfullyCreatedReminder: "Rappel créé avec succès !",
    successfullyUpdatedStatus: "Statut mis à jour avec succès !",
    successfullyUpdatedReminder: "Rappel mis à jour avec succès !",
    successfullyCreatedPayment: "Paiement créé avec succès !",
    successfullyCreatedCompanyParameters: "Paramètres de l'entreprise créés avec succès !",
    successfullyUpdatedTreasuryAccount: "Compte de trésorerie mis à jour avec succès !",
    successfullyAcceptedInvitation: "Invitation acceptée avec succès !",
    successfullyLoggedIn: "Connexion réussie !",
    successfullyUpdatedCompanySettings: "Paramètres de l'entreprise mis à jour avec succès !",
    successfullyCreatedCompany: "Entreprise créée avec succès !",
    successfullyDeletedPayment: "Paiement supprimé avec succès !",
    successfullyCreatedInvoice: "Facture créée avec succès !",
    successfullyDeletedReminder: "Rappel supprimé avec succès !",
    successfullyOrderSent: "Commande envoyée avec succès !",
    successfullyQuoteSent: "Devis envoyé avec succès !",
    successfullyCreatedOrder: "Commande créée avec succès !",
    successfullyCreatedDeliveryNote: "Bon de livraison créé avec succès !",
    successfullyDeliveryNoteSent: "Bon de livraison envoyé avec succès !",
    successfullyCreatedTreasuryAccount: "Compte de trésorerie créé avec succès !",
    successfullyUpdatedDefaultTreasuryAccount: "Compte de trésorerie par défaut mis à jour avec succès !",
    successfullyDeletedDocument: "Document supprimé avec succès !",
    successfullyDeletedTreasuryAccount: "Compte de trésorerie supprimé avec succès !",
    successfullyCreatedAccountingEntry: "Écriture comptable créée avec succès !",
    successfullyUpdatedAccountingEntry: "Écriture comptable mise à jour avec succès !",
    successfullyUpdatedBookingJournal: "Journaux comptable mis à jour avec succès !",
    successfulllyCreatedUser: "Utilisateur créé avec succès!",
    successfullyCreatedStorageCenter: "Centre de stockage créé avec succès !",
    successfullyUpdatedStorageCenter: "Centre de stockage mis à jour avec succès !",
    successfullyCreatedStorageOperations: "Opérations de stockage créées avec succès !",
    successfullyUpdatedPos: "Système de point de vente créé avec succès !",
    successfullyUpdatedUser: "Utilisateur mis à jour avec succès!",
    successfullyAddedAddress: "Adresse ajoutée avec succès !",
    successfullyUpdatedAddress: "Adresse mise à jour avec succès !",
    successfullyDeletedAddress: "Adresse supprimée avec succès !",
    successfullySetDefaultAddress: "Adresse par défaut définie avec succès !",
    successfullySentDocument: "Document envoyé avec succès !",
    successfullyUpdated: "Mis à jour avec succès !",

    // Answer sentences
    okGotIt: "Ok, compris",
    yesLogOut: "Oui, se déconnecter",
    noCancel: "Non, annuler",
    noContinue: "Non, continue",
    yesDelete: "Oui, supprimer",
    yesResolveError: "Oui, résoudre l'erreur",
    yesSelect: "Oui, sélectionner",
    yesCanceled: "Oui, annuler",
    okClose: "Ok, fermer",
    yesReject: "Oui, rejeter",
    yesGenerate: "Oui, générer",
    yesSend: "Oui, envoyer",
    yesChangeStatus: "Oui, changer le statut",
    yesCreateTreasuryAccount: "Oui, créer un compte de trésorerie",
    yesValidate: "Oui, valider",
    yesInvalidate: "Oui, invalider",
    yesUpload: "Oui, charge",
    noContinueForm: "Non, continuez avec le formulaire",
    yesAdd: "Oui, ajoutez",
    yesCreate: "Oui, créer",
    yesConfirm: "Oui, confirmer",

    // Suspensive sentences
    pleaseWait: "Veuillez patienter...",
    selectOption: "Sélectionner option...",
    searchContact: "Rechercher contact...",
    searchCategory: "Rechercher catégorie...",
    searchProduct: "Rechercher produit...",
    searchService: "Rechercher service...",
    searchStorage: "Rechercher un centre de stockage...",
    searchBookingJournal: "Rechercher journaux comptable...",
    searchAccountingAccount: "Rechercher compte comptable...",
    select: "Sélectionner...",
    search: "Rechercher...",
    writeCommentToInvite: "Écrivez un commentaire pour l'invitation...",
    loading: "Chargement...",
    roles: "Rôles",
    noRolesAvailable: "Aucun rôle disponible",
    noRolesDefinedForCompany: "Aucun rôle n'est défini pour cette société.",
    noAssignableRoles: "Votre rôle ne vous permet d'attribuer aucun rôle. Contactez un administrateur.",
    roleNotAssignableByYou: "Votre rôle ne vous permet pas d'attribuer ce rôle",
    roleAssignmentForbidden: "Votre rôle ne permet pas d'attribuer ce rôle",
    subscriptionExpiredAction: "Votre abonnement a expiré",
    system: "Système",
    administration: "Administration",
    admin: "Admin",
    member: "Membre",
    assignedRoles: "Rôles assignés",
    assignRole: "Assigner",
    removeRole: "Retirer",
    manageRoles: "Gérer les rôles",
    revoke: "Révoquer",
    reinvite: "Ré-inviter",
    invite: "Inviter",
    role: "Rôle",
    statusPending: "En attente",
    statusAccepted: "Acceptée",
    statusRejected: "Rejetée",
    statusExpired: "Expirée",
    expiresAt: "Expire le",
    noMembers: "Aucun membre trouvé",
    confirmRevoke: "Êtes-vous sûr de vouloir révoquer cette invitation ?",
    confirmRemoveRole: "Êtes-vous sûr de vouloir retirer ce rôle ?",
    policies: "Politiques",
    createRole: "Créer un rôle",
    createPolicy: "Créer une politique",
    attachedPolicies: "Politiques attachées",
    attachPolicy: "Attacher",
    detachPolicy: "Détacher",
    statements: "Déclarations",
    addStatement: "Ajouter une déclaration",
    removeStatement: "Supprimer la déclaration",
    effect: "Effet",
    allow: "Autoriser",
    deny: "Refuser",
    actionsList: "Actions",
    resources: "Ressources",
    resourcesHint: "Identifiants de ressources séparés par des virgules, utilisez * pour tout",
    noRoles: "Aucun rôle trouvé",
    noPolicies: "Aucune politique trouvée",
    confirmDeleteRole: "Êtes-vous sûr de vouloir supprimer ce rôle ?",
    confirmDeletePolicy: "Êtes-vous sûr de vouloir supprimer cette politique ?",
    systemReadOnly: "Cet élément système ne peut pas être modifié",
    loadingCatalog: "Chargement du catalogue de ressources...",
    emptyCatalog: "Aucune ressource disponible",
    advancedMode: "Avancé",
    preview: "Aperçu",

    // Abbreviated sentences
    n: "N°",
    mb: "MB",
    hrs: "hrs",
    min: "min",
    sec: "sec",

    // Enumeration
    first: "premier",
    second: "deuxième",
    third: "troisième",
    fourth: "quatrième",
    fifth: "cinquième",
    sixth: "sixième",

    // Languages
    english: "Anglais",
    french: "Français",
    italian: "Italien",
    german: "Allemand",
    spanish: "Espagnol",

    // Months
    january: "Janvier",
    february: "Février",
    march: "Mars",
    april: "Avril",
    may: "Mai",
    june: "Juin",
    july: "Juillet",
    august: "Août",
    september: "Septembre",
    october: "Octobre",
    november: "Novembre",
    december: "Décembre",

    // Periods
    monthly: "Mensuel",
    quarterly: "Trimestre",
    semiannual: "Semestriel",
    annual: "Annuel",
    createAccount: "Créer un compte",
    createSiblingAccount: "Créer un compte frère",
    createChildAccount: "Créer un sous-compte",
    siblingOf: "Frère de",
    subAccountOf: "Sous-compte de",
    nameFr: "Nom (français)",
    nameEn: "Nom (anglais)",
    nameDe: "Nom (allemand)",
    nameIt: "Nom (italien)",
    codeAndNameFrRequired: "Le code et le nom français sont obligatoires",
    accountCreatedSuccessfully: "Compte créé avec succès",
    renameAccount: "Renommer le compte",
    accountRenamedSuccessfully: "Compte renommé avec succès",
    siblingCodeHint: "4 chiffres — ex. 1005",
    childCodeHint: "XXXX.N — ex. 1000.01",
    siblingAccount: "Compte frère",
    subAccount: "Sous-compte",
    referenceAccount: "Compte de référence",
    creationMode: "Mode de création",
    foreignCurrency: "Devise étrangère",
    enableForeignCurrency: "Facturer en devise étrangère",
    exchangeRate: "Taux de change",
    exchangeDate: "Date du taux",
    foreignCurrencyPreview: "Aperçu du montant converti",
    convertedTotal: "Total converti",
    rateInfo: "Info taux de change",
    amountInCurrency: "Montant en {currency}",
    amountInCHF: "Montant CHF",
    partialBalance: "Partiel (sans conversion)",
    approxBalanceTooltip: "Ligne(s) sans taux de conversion — solde {currency} approximatif",
    partialLinesFooter: "partiel ({count} lignes sans taux)",
    currencyColumn: "Devise",
    vatPeriodicity: "Périodicité TVA",
    firstPeriod: "Première période",
    deductionMethod: "Méthode de déduction",
    methodInvoicing: "Sur la base de la facturation",
    methodCashing: "Sur la base de l'encaissement",
    periodConfigured: "Périodes fiscales configurées",
    periodOpen: "Ouverte",
    periodClosed: "Fermée",
    periodFiled: "Déposée",
    closePeriod: "Clôturer la période",
    taxSettingsLocked: "Les paramètres TVA sont verrouillés car une période fiscale a été créée. Pour les modifier, contactez votre fiduciaire.",
    taxSettingsLockedContact: "Si vous souhaitez modifier le régime TVA, vous devez contacter",
    period: "Période",
    format: "Format",
    reconciliation: "Rapprochement",
    bankStatements: "Relevés bancaires",
    importStatement: "Importer un relevé",
    importBankStatement: "Importer un relevé bancaire",
    allTreasuryAccounts: "Tous les comptes de trésorerie",
    statementDate: "Date du relevé",
    openingBalance: "Solde d'ouverture",
    closingBalance: "Solde de clôture",
    importFailed: "Échec de l'importation",
    dragAndDropOrClick: "Glissez-déposez un fichier ici, ou cliquez pour sélectionner",
    importing: "Importation...",
    importAction: "Importer",
    autoMatchInfo: "Après l'importation, un rapprochement automatique sera lancé pour faire correspondre les transactions avec les factures existantes.",
    importSourceStructured: "Fichier structuré (CAMT/CSV)",
    importSourcePdfUpload: "PDF — téléverser",
    importSourcePdfExisting: "PDF — document existant",
    extractingStatement: "Extraction du relevé en cours…",
    preparingDocument: "Préparation du document…",
    extractionFailed: "L'extraction a échoué. Réessayez.",
    selectExistingDocument: "Choisir un document existant",
    noPdfDocumentsAvailable: "Aucun document PDF disponible",
    retryExtraction: "Relancer l'extraction",
    extractionTimeout: "L'extraction prend plus de temps que prévu. Réessayez plus tard.",
    jobQueued: "En attente...",
    jobFailed: "Échoué",
    heuristicSuggestions: "Suggestions heuristiques",
    unmatchedLines: "Lignes non rapprochées",
    bankTransactions: "Transactions",
    oneStatementNeedingAttention: "1 relevé nécessite votre attention",
    statementsNeedingAttention: "relevés nécessitent votre attention",
    someTransactionsNotReconciled: "Certaines transactions ne sont pas encore rapprochées",
    continueReconciliation: "Continuer le rapprochement",
    finishReconciliation: "Terminer le rapprochement",
    counterpartIban: "IBAN contrepartie",
    matchedVia: "Méthode",
    noTransactionsFound: "Aucune transaction trouvée",
    viewStatement: "Voir le relevé",
    alreadyImported: "Déjà importée",
    overlapWarning: "Cette période chevauche {n} relevé(s) déjà importé(s) pour ce compte.",
    duplicatesUnchecked: "{x} transaction(s) déjà présente(s) décochée(s) automatiquement.",
    includeLine: "Inclure",
    confirmed: "Validé",
    sortByPeriod: "Trier par période",
    confirmDeleteStatement: "Supprimer le relevé brouillon ?",
    confirmDeleteStatementText: "Ce relevé brouillon et son document associé seront supprimés définitivement. Cette action est irréversible.",
    existingPayments: "Paiements déjà enregistrés",
    linkThisPayment: "Lier ce paiement",
    link: "Lier",
    autoMatchAll: "Rapprochement auto",
    exportTransactions: "Exporter les transactions",
    reconcile: "Rapprocher",
    reconcileAutomatically: "Rapprocher automatiquement",
    paid: "Payée",
    entry: "Écriture",
    documentsToValidate: "Documents à valider",
    validateAndReconcile: "Valider et rapprocher",
    toValidate: "À valider",
    dateFrom: "De",
    dateTo: "À",
    resetFilters: "Réinitialiser",
    transactions: "transactions",
    previous: "Précédent",
    next: "Suivant",
    matched: "Rapproché",
    ignored: "Ignoré",
    relaunchAutoMatch: "Relancer le rapprochement auto",
    matching: "Rapprochement",
    starting: "Démarrage",
    jobRunning: "Rapprochement auto en cours",
    linesProcessed: "Lignes traitées",
    noLinesPending: "Aucune ligne en attente",
    matchManually: "Rapprocher manuellement",
    match: "Rapprocher",
    unmatch: "Délier",
    ignore: "Ignorer",
    noLinesInStatement: "Aucune ligne dans ce relevé",
    statementNotFound: "Relevé introuvable",
    confirmUnmatch: "Délier cette ligne ?",
    unmatchWillDeleteEntry: "L'écriture comptable associée pourrait être supprimée.",
    yesUnmatch: "Oui, délier",
    confirmIgnore: "Ignorer cette ligne ?",
    yesIgnore: "Oui, ignorer",
    restoreLine: "Restaurer",
    lineRestored: "Ligne restaurée en attente.",
    saveDraft: "Enregistrer",
    draftSaved: "Brouillon enregistré.",
    savingDraft: "Enregistrement…",
    unsavedChanges: "Modifications non enregistrées",
    unsavedChangesBody: "Vous avez des modifications non enregistrées. Que souhaitez-vous faire ?",
    quitWithoutSaving: "Quitter sans enregistrer",
    statementNotDraft: "Ce relevé n'est plus un brouillon. Rechargement…",
    jobAlreadyRunning: "Le rapprochement auto est déjà en cours",
    noCandidatesFound: "Aucun candidat trouvé",
    reconcileAndCollect: "Rapprocher et encaisser",
    partialCollection: "encaissement partiel",
    score: "Score",
    pending: "En attente",
    deleteStatement: "Supprimer le relevé",
    confirmDeleteStatementTitle: "Supprimer ce relevé bancaire ?",
    confirmDeleteStatementBody: "Cette action supprime le relevé et ses {count} transaction(s) non rapprochée(s).",
    statementDeleted: "Relevé supprimé avec succès.",
    cannotDeleteMatchedLines: "Impossible : {count} transaction(s) rapprochée(s). Déliez d'abord les rapprochements.",
    cannotDeleteMatchedLinesTooltip: "Impossible : {count} transaction(s) rapprochée(s). Déliez d'abord les rapprochements.",
    statementHasMatchedLinesError: "Ce relevé contient {count} transaction(s) rapprochée(s). Déliez-les avant de supprimer.",
    invalidateStatement: "Invalider",
    confirmInvalidateStatementTitle: "Invalider ce relevé bancaire ?",
    confirmInvalidateStatementBody: "Le relevé repassera en brouillon pour correction. Ses {count} transaction(s) ne seront plus proposées au rapprochement. Le document importé reste attaché.",
    statementInvalidated: "Relevé repassé en brouillon.",
    confirmInvalidate: "Oui, invalider",

    // VAT Return
    vatReturn: "Décompte TVA",
    vatSectionTurnover: "I. Chiffre d'affaires",
    vatSectionTaxCalculation: "II. Calcul de l'impôt",
    vatSectionOtherFlows: "III. Autres mouvements de fonds",
    vatTaxDue: "Impôt dû",
    vatInputTax: "Impôt préalable",
    vatBalance: "Solde en faveur de l'AFC / de l'assujetti",
    vatTax: "Impôt",
    vatCaseComposition: "Composition de la case",
    vatCounterServices: "Contre-prestations",
    vatDeductions: "Déductions",
    vatTaxableTurnover: "Chiffre d'affaires imposable",
    vatAmountToPayAFC: "Montant à payer à l'AFC",
    vatBalanceInFavor: "Solde en faveur de l'assujetti",
    vatTotalDeductions: "Total des déductions",
    vatTotalTaxDue: "Total de l'impôt dû",
    vatTotalInputTax: "Total de l'impôt préalable",
    vatNormalRate: "Prestations soumises au taux normal",
    vatReducedRate: "Prestations soumises au taux réduit",
    vatAccommodationRate: "Prestations soumises au taux spécial",
    vatAcquisitions: "Impôt sur les acquisitions (net, excl. TVA)",
    caseNumber: "Case",
    base: "Base",
    sign: "Signe",
    nature: "Nature",
    reference: "Référence",
    back: "Retour",
    accountingDocument: "Pièce comptable",
    documentNumber: "Numéro de pièce",
    entryNumber: "Numéro d'écriture",
    entryNumberShort: "N°",
    manualEntry: "Écriture manuelle",
    createAndReconcile: "Créer et rapprocher",
    gap: "Écart",
    editVatAdjustment: "Modifier l'ajustement TVA",
    noteOptional: "Note (optionnel)",
    vouchersSoonAvailable: "Justificatifs (bientôt disponible)",
    periodIsFiledCannotEdit: "Cette période est clôturée. Les ajustements ne peuvent pas être modifiés.",
    csvImport: "Import CSV",
    difference: "Écart",
    balanced: "Équilibré",
    unbalanced: "Déséquilibré",
    saveOpeningBalance: "Enregistrer le bilan d'ouverture",
    forceReprise: "Forcer la reprise",
    forceRepriseWarning: "L'exercice précédent est clôturé. Forcer écrasera l'écriture d'à-nouveau automatique. Êtes-vous sûr ?",
    csvFormatHelp: "Formats CSV acceptés (séparateur point-virgule) :",
    csvFormatBHelp: "1000;15000 (positif = débit, négatif = crédit)",
    closedFiscalYearReadonly: "Cet exercice est clôturé. Le bilan d'ouverture ne peut pas être modifié.",
    deleteOpeningBalance: "Supprimer le bilan d'ouverture",
    confirmDeleteOpeningBalance: "Voulez-vous vraiment supprimer le bilan d'ouverture ? Tous les montants seront remis à zéro.",
    amountMustBePositive: "Le montant doit être positif — utilisez la colonne débit ou crédit.",

    // Period status transitions
    filePeriod: "Déposer",
    reopenPeriod: "Réouvrir",
    confirmClosePeriod: "Voulez-vous vraiment clôturer cette période ? Les écritures ne seront plus modifiables tant que la période ne sera pas réouverte.",
    confirmFilePeriod: "Voulez-vous vraiment déposer cette période ? Cette action est définitive et ne peut pas être annulée.",
    confirmFilePeriodWarning: "Une fois déposé, le décompte TVA sera figé et aucune modification ne sera possible.",
    confirmReopenPeriod: "Voulez-vous vraiment réouvrir cette période ? Les écritures redeviendront modifiables.",

    // Fiscal Years
    fiscalYears: "Exercices comptables",
    fiscalYear: "Exercice comptable",
    newFiscalYear: "Nouvel exercice",
    closeFiscalYear: "Clôturer l'exercice",
    closeFiscalYearConfirm: "Voulez-vous vraiment clôturer cet exercice comptable ? Cette action est irréversible. Toutes les écritures seront verrouillées et aucune modification ne sera possible.",
    closeFiscalYearWarning: "Cette action est irréversible. Une fois clôturé, aucune écriture ne pourra être ajoutée ou modifiée pour cet exercice.",
    reopenFiscalYear: "Réouvrir l'exercice",
    reopenFiscalYearConfirm: "Voulez-vous vraiment réouvrir cet exercice comptable ?",
    reopenFiscalYearWarning: "L'écriture de clôture, le report à nouveau et l'affectation du résultat de l'exercice suivant seront supprimés. Les périodes seront rouvertes. Vous pourrez re-clôturer ensuite.",
    reopenFiscalYearFirstReopen: "Réouvrez d'abord l'exercice {name}",
    noFiscalYears: "Aucun exercice comptable trouvé",
    createFiscalYear: "Créer un exercice",
    editFiscalYear: "Modifier l'exercice",
    deleteFiscalYear: "Supprimer l'exercice",
    confirmDeleteFiscalYear: "Voulez-vous vraiment supprimer définitivement cet exercice comptable ? Cette action est irréversible.",
    fiscalYearStartDate: "Date de début de l'exercice",
    fiscalYearClosingYear: "Année de clôture",
    fiscalYearEndDate: "Date de fin de l'exercice",
    fiscalYearEndForced: "L'exercice comptable se termine toujours au 31 décembre",
    accountingSettingsInitializing: "Initialisation en cours…",

    // Annual correction
    annualCorrection: "Concordance annuelle",
    createAnnualCorrection: "Créer la concordance annuelle",
    viewAnnualCorrection: "Voir la concordance",
    confirmCreateAnnualCorrection: "Créer la concordance annuelle pour cet exercice ? Les tickets orphelins seront rattachés à une nouvelle période de concordance.",
    periodsNotAllFiled: "Toutes les périodes doivent être déposées avant de créer la concordance annuelle.",
    noOrphans: "Aucun ticket orphelin à corriger pour cet exercice.",
    ticketsPending: "tickets en attente",

    // Vouchers
    confirmDeleteVoucher: "Voulez-vous vraiment supprimer ce justificatif ?",
    pendingUpload: "en attente",
    uploadFailed: "L'envoi a échoué pour un ou plusieurs fichiers. Le montant et la note ont été enregistrés.",
    addVoucher: "Ajouter un justificatif",

    // Manual entries
    vatInputType: "Nature de l'impôt préalable",
    vatInputGoods: "Marchandises et matériel",
    vatInputInvestment: "Investissements et autres charges",
    deleteAccountingEntry: "Supprimer l'écriture",
    confirmDeleteAccountingEntry: "Voulez-vous vraiment supprimer cette écriture ?",

    // Financial statements
    balanceSheet: "Bilan",
    incomeStatement: "Compte de résultat",
    trialBalance: "Balance de vérification",
    assets: "Actif",
    liabilities: "Passif",
    revenue: "Produits",
    netResult: "Résultat de l'exercice",
    asOfDate: "Au",
    previousYear: "Exercice précédent",
    variation: "Variation",
    notBalanced: "Non équilibré",
    sortByCode: "Trier par compte",
    sortByBalance: "Trier par solde",
    allLevels: "Tous les niveaux",
    profitOfYear: "Bénéfice de l'exercice",
    lossOfYear: "Perte de l'exercice",
    viewList: "Liste",
    viewColumns: "Côte à côte",
    totalLiabilitiesAndResult: "Total passifs & résultat",
    viewVouchers: "Voir les pièces",
    pendingDocuments: "document(s) en attente",
    showZeroAccounts: "Afficher les comptes à zéro",
    hideZeroAccounts: "Masquer les comptes à zéro",
    chatTitle: "Chat",
    chatConversations: "Conversations",
    chatNewConversation: "Nouvelle conversation",
    chatNoConversations: "Aucune conversation",
    chatNoMessages: "Aucun message. Dites bonjour !",
    chatPlaceholder: "Saisissez un message...",
    chatSend: "Envoyer",
    chatYou: "Vous",
    chatBack: "Retour",
    chatStartConversation: "Chat",
    chatSelectMember: "Sélectionner un membre",
    chatLoadingMembers: "Chargement des membres...",
    chatNoMembers: "Aucun membre trouvé",
    chatLoadingMessages: "Chargement des messages...",
    chatActive: "Actif",
    featureLabelContacts: "Contacts & CRM",
    featureLabelSaleCore: "Ventes & facturation",
    featureLabelPurchaseCore: "Achats & factures fournisseurs",
    featureLabelTreasuryPayments: "Paiements & rapprochement bancaire",
    featureLabelCatalog: "Catalogue de produits & services",
    featureLabelAccountingCore: "Comptabilité",
    featureLabelArchiveOcr: "Archivage de documents & OCR",
    featureLabelNetworkInterbilling: "Facturation inter-sociétés",
    featureLabelPaymentOnline: "Paiements en ligne",
    featureLabelDunning: "Relances & rappels",
    featureLabelSaleRecurring: "Facturation récurrente",
    featureLabelTreasuryEbanking: "Connexion e-banking",
    featureLabelTreasuryForecast: "Prévision de trésorerie",
    featureLabelProjectsTime: "Projets & suivi du temps",
    featureLabelPos: "Point de vente",
    featureLabelExpenses: "Notes de frais",
    featureLabelInventory: "Gestion des stocks",
    featureLabelSaleConsignment: "Ventes en consignation",
    featureLabelAccountingAssets: "Gestion des immobilisations",
    featureLabelServiceRepair: "Suivi des réparations",
    featureLabelRbacAdvanced: "Contrôle d'accès avancé",
    featureLabelMultiCompany: "Multi-sociétés",
    featureLabelPayroll: "Gestion des salaires",
    featureLabelStorefront: "Boutique en ligne",
    featureLabelEsignature: "Signature électronique",
    featureLabelMobileSale: "Application mobile de vente",
    featureLabelMobileExpenses: "Saisie mobile des frais",
    featureLabelSupportPriority: "Support prioritaire",
    searchDocuments: "Rechercher des documents",
    searchDocumentsPlaceholder: "Rechercher dans les documents (nom, contenu OCR)...",
    searchingDocuments: "Recherche en cours...",
    searchDocumentsResultsCount: "{{count}} résultat(s) pour « {{query}} »",
    searchDocumentsNoResults: "Aucun résultat pour « {{query}} »",
    filterDocumentStatus: "Statut du document",
    filterDocumentDateFrom: "Date du document depuis",
    filterDocumentDateTo: "Date du document jusqu'au",
    filterUploadDateFrom: "Date d'envoi depuis",
    filterUploadDateTo: "Date d'envoi jusqu'au",
    statementToValidate: "Relevé à valider",
    draftMode: "Mode brouillon",
    confirmImport: "Confirmer l'import",
    extractedByVision: "Extrait par analyse d'image",
    extractedByText: "Extrait par texte",
    reconciliationGapWarning: "Écart de {gap} — vérifiez les lignes",
    confirmUnbalancedTitle: "Relevé non équilibré",
    confirmUnbalancedText: "Le relevé n'est pas équilibré. Confirmer quand même ?",
    ocrStatus: "Statut OCR",
    uploadedAt: "Téléversé le",
    pageXofN: "Page {page} sur {pages}",
    filterByStatus: "Filtrer par statut",
    allStatuses: "Tous",
    statusNew: "Nouveau",
    statusAssigned: "Assigné",
    statusPartiallyProcessed: "Partiellement traité",
    statusProcessed: "Traité",
    createFullInvoice: "Facture complète",
    depositInvoice: "Facture d'acompte",
    partialInvoice: "Facture partielle",
    depositAmount: "Montant de l'acompte",
    depositDescription: "Description",
    quantityToInvoice: "Quantité à facturer",
    remainingQuantity: "Restant",
    invoicedQuantity: "Facturé",
    totalQuantity: "Total",
    notInvoiced: "Non facturée",
    partiallyInvoiced: "Partiellement facturée",
    fullyInvoiced: "Entièrement facturée",
    invoicingStatus: "Statut de facturation",
    invoicedAmountOf: "facturé sur",
    linkedInvoices: "Factures liées",
    noInvoicesYet: "Aucune facture pour le moment",
    youWantToCreateDepositInvoice: "Voulez-vous créer une facture d'acompte ?",
    youWantToCreatePartialInvoice: "Voulez-vous créer une facture partielle ?",
    noLinesToInvoice: "Aucune ligne à facturer",
    depositAmountExceedsRemaining: "Le montant dépasse le solde restant",
    manageStock: "Gérer le stock",
    stockManagedDescription: "Chaque vente décrémentera automatiquement le stock du centre de stockage.",
    stockDisabledDescription: "Aucun mouvement de stock ne sera généré pour les ventes de cette caisse.",
    stockManaged: "Stock géré",
    withoutStockManagement: "Sans gestion de stock",
    recipient: "Destinataire",
    emailSubject: "Sujet",
    emailMessage: "Message",
    emailSent: "Email envoyé avec succès",
    emailDefaultMessage: "Veuillez trouver ci-joint le document mentionné en objet.",
    correctAccounts: "Corriger les comptes",
    saveCorrection: "Enregistrer la correction",
    correctingAccountsDescription: "Vous pouvez corriger les comptes de contrepartie de ce document. L'écriture comptable sera mise à jour en place.",
    successfullyCorrectedAccounts: "Comptes corrigés avec succès",

    // Payroll
    payroll: "Salaires",
    payrollShort: "Salaires",
    employees: "Salariés",
    addEmployee: "Ajouter un salarié",
    editEmployee: "Modifier le salarié",
    employeeNumber: "Numéro de salarié",
    searchEmployee: "Rechercher un salarié...",
    noEmployeesFound: "Aucun salarié trouvé",
    employeeStatusActive: "Actif",
    employeeStatusDraft: "Brouillon",
    employeeStatusTerminated: "Résilié",
    workCanton: "Canton de travail",
    activityRate: "Taux d'activité",
    employmentContract: "Contrat de travail",
    avsNumber: "Numéro AVS",
    residencePermit: "Autorisation de séjour",
    backToList: "Retour à la liste",
    backToDashboard: "Retour au tableau de bord",
    featureComingSoon: "Cette fonctionnalité sera bientôt disponible.",
    payrollAccessDenied: "Accès refusé",
    payrollAccessDeniedOwnerOnly: "Le module salaires est réservé au propriétaire de l'entreprise. Contactez votre administrateur si vous pensez devoir y avoir accès.",
    payrollAccessDeniedReconnect: "Si vos permissions ont été récemment mises à jour, veuillez vous déconnecter et vous reconnecter pour actualiser votre session.",

    // Payroll forms
    identity: "Identité",
    birthDate: "Date de naissance",
    gender: "Genre",
    gender_male: "Masculin",
    gender_female: "Féminin",
    civilStatus: "État civil",
    civilStatus_single: "Célibataire",
    civilStatus_married: "Marié(e)",
    civilStatus_divorced: "Divorcé(e)",
    civilStatus_widowed: "Veuf/veuve",
    civilStatus_registered_partnership: "Partenariat enregistré",
    civilStatus_dissolved_partnership: "Partenariat dissous",
    civilStatusSince: "État civil depuis le",
    civilStatusSinceHelp: "Détermine le barème d'impôt à la source applicable. Un changement d'état civil prend effet le mois suivant l'événement.",
    nationality: "Nationalité",
    permitType: "Type de permis",
    permitNumber: "Numéro de permis",
    permitValidUntil: "Valable jusqu'au",
    issuingCanton: "Canton de délivrance",
    swissNational: "Nationalité suisse",
    permit: "Permis",
    residence: "Domicile",
    canton: "Canton",
    municipality: "Commune",
    familySituation: "Situation familiale",
    hasSpouse: "A un conjoint / partenaire enregistré",
    spouseIsWorking: "Le conjoint travaille",
    spouseWorkCanton: "Canton de travail du conjoint",
    spouseWorkCountry: "Pays de travail du conjoint",
    children: "Enfants",
    addChild: "Ajouter un enfant",
    child: "Enfant",
    allowanceFrom: "Allocation dès",
    allowanceTo: "Allocation jusqu'au",
    inEducation: "En formation",
    paymentDetails: "Coordonnées de paiement",
    bic: "BIC/SWIFT",
    accountHolder: "Titulaire du compte",
    notes: "Remarques",
    linkedContact: "Contact lié",
    searchContact: "Rechercher un contact existant...",
    contactRequired: "Veuillez sélectionner un contact",
    refreshSnapshot: "Actualiser les données du contact",
    change: "Modifier",

    // Contract form
    contractHistory: "Historique des contrats",
    addContractVersion: "Ajouter une version de contrat",
    newContractVersion: "Nouvelle version du contrat",
    editContract: "Modifier le contrat",
    newVersionWarning: "Ceci créera la version {version} du contrat, prenant effet à la date indiquée. La version {prevVersion} sera clôturée automatiquement.",
    contractType: "Type de contrat",
    contractType_permanent: "Durée indéterminée",
    contractType_fixed_term: "Durée déterminée",
    contractType_apprenticeship: "Apprentissage",
    contractType_internship: "Stage",
    salaryMode: "Mode salarial",
    salaryMode_monthly: "Mensuel",
    salaryMode_hourly: "Horaire",
    hireDate: "Date d'embauche",
    endReason: "Motif de fin",
    weeklyHours: "Heures hebdomadaires",
    probationMonths: "Période d'essai (mois)",
    noticePeriod: "Délai de congé (mois)",
    salary: "Salaire",
    baseSalary: "Salaire de base",
    thirteenthSalary: "13ème salaire",
    thirteenthMode: "Mode de versement",
    thirteenthMode_december: "Décembre",
    thirteenthMode_monthly_provision: "Provision mensuelle",
    thirteenthModeHelp: "Versement en décembre — le 13e salaire est versé intégralement en décembre. En cas de départ en cours d'année, la part acquise est versée au décompte final.\n\nProvision mensuelle — un douzième est versé chaque mois avec la paie courante. Aucun versement en décembre.",
    vacation: "Vacances",
    vacationDays: "Jours par année",
    vacationRate: "Taux vacances (%)",
    workplace: "Lieu de travail",
    workplaceAddressCompany: "Adresse de l'entreprise",
    workplaceAddressOther: "Autre adresse",
    validFrom: "Valable dès",
    validTo: "Jusqu'au",
    version: "Version",
    current: "En cours",
    closed: "Clôturé",
    future: "Futur",
    noContracts: "Aucun contrat",
    // Contract termination
    terminateContract: "Résilier le contrat",
    confirmTermination: "Confirmer la résiliation",
    terminationConsequences: "La résiliation du contrat aura les effets suivants :",
    terminationStatusChange: "Le statut du salarié passera à <strong>résilié</strong>",
    terminationFinalSettlement: "Un <strong>décompte final</strong> sera produit sur la période de paie contenant cette date",
    terminationExclusion: "Le salarié sera <strong>exclu des cycles de paie suivants</strong>, sauf pour les ajustements rétroactifs",
    terminationWarning: "La résiliation d'un contrat déclenche un décompte final sur la période de paie contenant la date de fin. Cette action peut être annulée avant la validation du cycle de paie.",
    contractTerminated: "Contrat résilié",
    cancelTermination: "Annuler la résiliation",
    cancelTerminationConfirm: "Êtes-vous sûr de vouloir annuler cette résiliation ? Le salarié reprendra le statut actif.",
    terminationCancelled: "Résiliation annulée",
    terminated: "Résilié",
    endReason_resignation: "Démission",
    endReason_dismissal: "Licenciement",
    endReason_mutual_agreement: "Accord mutuel",
    endReason_end_of_term: "Fin du terme",
    endReason_retirement: "Retraite",
    endReason_death: "Décès",
    endReason_disability: "Invalidité",
    endReason_probation: "Fin de période d'essai",

    // Payroll — Company salary settings
    salarySettings: "Paramètres salariaux",
    insurancePlans: "Plans d'assurance",
    payrollSettings: "Paramètres de paie",
    payrollCompleteness: "État de préparation",
    payrollCompletenessOk: "Tous les paramètres requis sont configurés. La paie peut être calculée.",
    payrollCompletenessMissing: "Les paramètres suivants doivent être complétés avant de pouvoir calculer la paie :",
    insurancePlanType_laap: "LAA Professionnelle (LAAP)",
    insurancePlanType_laanp: "LAA Non professionnelle (LAANP)",
    insurancePlanType_laac: "LAA Complémentaire (LAAC)",
    insurancePlanType_ijm: "Indemnité journalière maladie (IJM)",
    insurancePlanType_lpp: "Prévoyance professionnelle (LPP)",
    insurerName: "Nom de l'assureur",
    policyNumber: "Numéro de police",
    rateEmployee: "Taux employé (%)",
    rateEmployer: "Taux employeur (%)",
    riskClass: "Classe de risque",
    lppRatesByAge: "Taux par tranche d'âge",
    lppAgeFrom: "Dès",
    lppAgeTo: "Jusqu'à",
    addAgeBracket: "Ajouter une tranche d'âge",
    coordinationDeductionOverride: "Déduction de coordination (surcharge)",
    entryThresholdOverride: "Seuil d'entrée (surcharge)",
    addInsurancePlan: "Ajouter un plan d'assurance",
    editInsurancePlan: "Modifier le plan d'assurance",
    noInsurancePlans: "Aucun plan d'assurance",
    effectiveSince: "En vigueur depuis le {date}",
    closurePlanWarning: "Ce plan prendra effet le {date}. Le plan {type} en cours sera clôturé le {closureDate}.",
    confirmDeletePlan: "Êtes-vous sûr de vouloir supprimer ce plan d'assurance ?",
    deletePlan: "Supprimer le plan",
    avsFund: "Caisse AVS",
    avsFundName: "Nom de la caisse",
    avsMemberNumber: "Numéro d'affilié",
    avsAdministrationRate: "Taux d'administration (%)",
    familyAllowanceFund: "Caisse d'allocations familiales",
    familyAllowanceFundName: "Nom de la caisse",
    familyAllowanceMemberNumber: "Numéro d'affilié",
    withholdingTax: "Impôt à la source",
    withholdingTaxCanton: "Canton fiscal",
    withholdingTaxDebtorNumber: "Numéro de débiteur",
    withholdingTaxPeriodicity: "Périodicité de déclaration",
    periodicityMonthly: "Mensuelle",
    periodicityQuarterly: "Trimestrielle",
    periodicityAnnual: "Annuelle",
    payFrequency: "Fréquence de paie",
    payFrequencyMonthly: "Mensuelle",
    payFrequencySemiMonthly: "Bi-mensuelle",
    payFrequencyWeekly: "Hebdomadaire",
    missingActiveLaap: "Plan LAAP actif avec taux employeur",
    missingActiveLaanp: "Plan LAANP actif avec taux employé",
    missingActiveLpp: "Plan LPP actif avec tranches d'âge",
    missingAvsFundName: "Nom de la caisse AVS",
    missingAvsAdminRate: "Taux d'administration AVS",
    missingFamilyAllowanceFundName: "Nom de la caisse d'allocations familiales",
    missingAvsAdminBase: "Base de calcul des frais d'administration AVS",
    missingFamilyAllowanceRate: "Taux de cotisation allocations familiales",
    administrationBase: "Base de calcul des frais",
    administrationBaseAvsContributions: "Cotisations AVS/AI/APG",
    administrationBaseGrossAvs: "Masse salariale soumise AVS",
    administrationBaseHelp: "Selon votre caisse, le taux s'applique soit au montant des cotisations AVS/AI/APG, soit à la masse salariale brute. Cette information figure sur votre décompte de caisse.",
    familyAllowanceContributionRate: "Taux de cotisation employeur",
    familyAllowanceRateHelp: "Ce taux dépend de la caisse d'affiliation, pas du canton. Deux entreprises dans le même canton affiliées à des caisses différentes paient des taux différents.",
    expenseRegulation: "Règlement de frais",
    expenseRegulationApproved: "Règlement de frais approuvé",
    expenseRegulationCanton: "Canton d'approbation",
    expenseRegulationDate: "Date d'approbation",
    expenseRegulationReference: "Numéro de référence",
    withholdingTaxNote: "La configuration de l'impôt à la source est partielle. Le support complet (consultation des barèmes, corrections annuelles) est prévu pour une version ultérieure.",
    showPlanHistory: "Afficher l'historique",
    hidePlanHistory: "Masquer l'historique",

    // Payroll — Payroll runs
    payrollRuns: "Cycles de paie",
    payrollRun: "Cycle de paie",
    payslip: "Bulletin de salaire",
    payslips: "Bulletins de salaire",
    openPeriod: "Ouvrir une période",
    period: "Période",
    employeeCount: "Salariés",
    grossTotal: "Brut",
    netTotal: "Net",
    employerCost: "Coût employeur",
    totalDeductions: "Retenues",
    totalEmployerCharges: "Charges patronales",
    validatedAt: "Validé le",
    calculate: "Calculer",
    recalculate: "Recalculer",
    validate: "Valider",
    markAsPaid: "Marquer payé",
    cancelRun: "Annuler",
    regeneratePdfs: "Régénérer les PDF",
    downloadSummary: "Télécharger le récapitulatif",
    downloadPayslip: "Télécharger le bulletin",
    calculating: "Calcul en cours...",
    calculatingProgress: "Calcul en cours. Cela peut prendre quelques minutes.",
    calculatingTimeout: "Le calcul prend plus de temps que prévu. Vous pouvez réessayer.",
    retryCalculation: "Relancer le calcul",
    noPayrollRuns: "Aucun cycle de paie",
    noPayslips: "Aucun bulletin",
    createPayrollRun: "Ouvrir une période de paie",
    periodAlreadyExists: "Un cycle de paie existe déjà pour cette période.",
    periodAlreadyExistsLink: "Voir le cycle existant",
    confirmValidateTitle: "Valider le cycle de paie",
    confirmValidateBody: "{count} bulletins — Brut : {gross} — Net : {net} — Coût employeur : {employerCost}",
    confirmValidateIrreversible: "Cette action est irréversible. Les bulletins seront figés et les PDF générés. Toute correction passera par une annulation ou un rétroactif.",
    confirmValidateFinalSettlements: "Ce cycle contient {count} décompte(s) final(aux).",
    confirmValidateNegativeNets: "Ce cycle contient {count} bulletin(s) avec un net négatif.",
    confirmCancelTitle: "Annuler le cycle de paie",
    cancellationReason: "Motif d'annulation",
    cancellationReasonRequired: "Un motif est requis pour annuler un cycle de paie.",
    confirmPayTitle: "Marquer comme payé",
    confirmPayBody: "Confirmer que {count} bulletins pour un total de {net} net ont été payés.",
    payslipProvisional: "Provisoire — non validé",
    provisional: "Provisoire",
    interim: "Intermédiaire",
    ancillaryActivities: "Activités annexes",
    extraordinaryItems: "Hors exploitation et extraordinaire",
    payslipFailed: "Échec du calcul",
    controlPanel: "Panneau de contrôle",
    failedPayslips: "Bulletins en échec",
    failedPayslipsBlocking: "Validation bloquée : {count} bulletin(s) en échec.",
    excludedEmployees: "Salariés exclus",
    runWarnings: "Signalements",
    finalSettlements: "Décomptes finaux",
    negativeNets: "Nets négatifs",
    retroactiveOnly: "Rétroactifs seuls",
    runStatusDraft: "Brouillon",
    runStatusCalculating: "En cours de calcul",
    runStatusCalculated: "Calculé",
    runStatusValidated: "Validé",
    runStatusPaid: "Payé",
    runStatusCancelled: "Annulé",
    exclusionStatusDraft: "Salarié en statut brouillon",
    exclusionStatusTerminated: "Contrat de travail terminé",
    exclusionNoContract: "Aucun contrat actif",
    exclusionHireAfterPeriod: "Embauché après la période",
    exclusionContractEndedBeforePeriod: "Contrat terminé avant la période",
    warningLppNotVerifiableHourly: "Les cotisations LPP n'ont pas pu être vérifiées pour les salariés horaires",
    warningPdfGenerationFailed: "La génération du PDF a échoué pour ce bulletin",
    warningHasAbsence: "Ce salarié a des absences sur la période",
    warningHourlyAbsenceNotDeducted: "Salarié horaire avec absences — la déduction n'est pas appliquée automatiquement",
    warningHourlyZeroGross: "Salarié horaire avec un salaire brut à zéro",

    // Monthly declaration
    monthlyDeclaration: "Déclaration mensuelle",
    monthlyDeclarations: "Déclarations mensuelles",
    socialInsuranceDays: "Jours AS",
    absenceDays: "Jours d'absence",
    effectiveWorkingDays: "Jours de travail effectifs",
    workingHours: "Heures",
    absences: "Absences",
    addAbsence: "Ajouter une absence",
    editAbsence: "Modifier l'absence",
    deleteAbsence: "Supprimer l'absence",
    absenceOngoing: "En cours",
    daysRetained: "{days} jour(s) retenu(s)",
    declarationValidated: "Validée",
    declarationDraft: "Brouillon",
    validateDeclaration: "Valider la déclaration",
    validateAllDeclarations: "Tout valider",
    saveDeclaration: "Enregistrer",
    noEligibleEmployees: "Aucun salarié éligible pour ce cycle",
    hourlyNoHoursWarning: "Salarié horaire sans heures saisies — le bulletin sera à zéro",
    declarationNotValidated: "Déclaration non validée",
    recalculationNeeded: "Les variables de paie ont été modifiées depuis le dernier calcul. Un recalcul est nécessaire avant validation.",
    loadError: "Erreur de chargement des données",
    retry: "Réessayer",
    punctualRubriques: "Rubriques ponctuelles",
    addRubrique: "Ajouter une rubrique",
    removeRubrique: "Retirer",
    rubriqueCode: "Code",
    rubriqueLabel: "Libellé",
    rubriqueAmount: "Montant",
    rubriqueQuantity: "Quantité",
    rubriqueRate: "Taux",
    rubriqueCalculationMode: "Mode de calcul",
    declarationFor: "Déclaration de {name}",
    backToRun: "Retour au cycle",
    editDeclaration: "Saisir les variables",
    activityRate: "Taux d'activité",
    noRubriques: "Aucune rubrique ponctuelle",
    saveAndClose: "Enregistrer et fermer",

    // Absence reasons
    absenceReason: "Motif d'absence",
    absenceReasonIllness: "Maladie",
    absenceReasonAccidentOccupational: "Accident professionnel",
    absenceReasonAccidentNonOccupational: "Accident non professionnel",
    absenceReasonMilitaryService: "Service militaire",
    absenceReasonMaternity: "Maternité",
    absenceReasonPaternity: "Paternité",
    absenceReasonUnpaid: "Absence non payée",
    absenceReasonUnjustified: "Absence injustifiée",
    incapacityRate: "Taux d'incapacité",
    salaryContinuationRate: "Maintien du salaire",
    absenceFrom: "Du",
    absenceTo: "Au",
    absenceToHelp: "Laisser vide si l'absence est en cours",
    confirmDeleteAbsence: "Êtes-vous sûr de vouloir supprimer cette absence ?",

    // Absence report
    absenceReport: "Rapport d'absences",
    absenceHistory: "Historique des absences",
    totalByReason: "Total par motif",
    noAbsences: "Aucune absence",
    filterByYear: "Filtrer par année",
    filterByReason: "Filtrer par motif",
    allReasons: "Tous les motifs",
    goToPayrollRun: "Voir le cycle de paie",
    companySnapshotIncomplete: "Les données de l'entreprise sont incomplètes (nom, adresse ou numéro IDE manquant). Les bulletins PDF pourraient être affectés.",
    companySettings: "Aller aux paramètres de l'entreprise",
    validateBlockedByFailures: "Validation impossible : il y a des bulletins en échec",
    backToPayrollRuns: "Retour aux cycles de paie",
    year: "Année",

    // Zod error map
    zodFieldRequired: "Ce champ est requis",
    zodInvalidType: "Valeur invalide",
    zodTooShort: "Minimum {min} caractères",
    zodTooLong: "Maximum {max} caractères",
    zodNumberTooSmall: "Doit être au moins {min}",
    zodNumberTooBig: "Doit être au plus {max}",
    zodArrayTooShort: "Au moins {min} élément(s) requis",
    zodInvalidEmail: "Adresse email invalide",
    zodInvalidFormat: "Format invalide",
    zodInvalidSelection: "Veuillez sélectionner une option valide",
    zodInvalidDate: "Date invalide",
    zodInvalidValue: "Valeur invalide",

    // Reconciliation indicators
    reconciled: "Rapproché",
    notReconciled: "Non rapproché",
    filteredTotalsWarning: "Les totaux correspondent au filtre actif, pas au compte entier",

    // Recurring contracts
    recurringContracts: "Contrats récurrents",
    recurringContract: "Contrat récurrent",
    addRecurringContract: "Ajouter un contrat récurrent",
    createRecurringContract: "Créer un contrat récurrent",
    updateRecurringContract: "Modifier le contrat récurrent",
    viewRecurringContract: "Détails du contrat récurrent",
    searchRecurringContract: "Rechercher un contrat...",
    allStatuses: "Tous les statuts",
    frequency: "Fréquence",
    monthly: "Mensuel",
    quarterly: "Trimestriel",
    semiAnnual: "Semestriel",
    annual: "Annuel",
    nextInvoiceDate: "Prochaine facture",
    generateInvoice: "Générer une facture",
    generateInvoiceConfirm: "Une facture sera créée à partir de ce contrat.",
    invoiceGenerated: "Facture générée",
    generatedInvoices: "Factures générées",
    pause: "Suspendre",
    paused: "Suspendu",
    activate: "Activer",
    changeStatusTo: "Changer le statut en",
    ended: "Terminé",
    every: "Tous les",
    quarters: "trimestres",
    anchorDay: "Jour du mois",
    issueOffsetDays: "Émission anticipée (jours)",
    autoValidate: "Validation automatique",
    autoSend: "Envoi automatique",
    autoBilling: "Facturation automatique (valider et envoyer)",
    autoBillingRequiresAccount: "Le service sélectionné n'a pas de compte comptable configuré ; la facturation automatique nécessite un compte.",
    autoRenew: "Reconduction tacite",
    autoRenewHint: "Renouveler automatiquement le contrat à son échéance",
    renewDaysBefore: "Renouveler jours avant la fin",
    renewDaysBeforeHint: "Nombre de jours avant la fin pour déclencher le renouvellement automatique",
    renewNow: "Renouveler maintenant",
    renewConfirm: "Le contrat sera prolongé d'une période supplémentaire.",
    contractRenewed: "Contrat renouvelé",
    lifecycleHistory: "Historique du cycle de vie",
    eventRenewed: "Renouvelé",
    eventEnded: "Terminé",
    triggerAuto: "Automatique",
    triggerManual: "Manuel",
    noLifecycleEvents: "Aucun événement",
    renewalCount: "Reconductions",
    paymentTermsDays: "Délai de paiement (jours)",

    // Bank statement extraction retry
    retryExtraction: "Relancer l'extraction",
    extractionFailedRetry: "L'extraction a échoué. Vous pouvez la relancer.",
    extractionEmptyRetry: "L'extraction est terminée mais aucune ligne n'a été trouvée. Vous pouvez relancer.",
    extractionInProgress: "Extraction en cours…",
    retrying: "Relance en cours…",

    // Dunning policies
    dunningPolicies: "Politiques de relance",
    dunningLabelRequired: "Le nom de la politique est requis",
    dunningStepsRequired: "Au moins une étape est requise",
    editDunningPolicy: "Modifier la politique de relance",
    addDunningPolicy: "Ajouter une politique de relance",
    appliesTo: "S'applique à",
    both: "Les deux",
    setAsDefault: "Politique par défaut",
    stopAfterLastStep: "Arrêter après la dernière étape",
    dunningSteps: "Étapes de relance",
    addStep: "Ajouter une étape",
    step: "Étape",
    offsetDays: "Décalage (jours depuis l'échéance)",
    offsetDaysHint: "Négatif = avant échéance (rappel de courtoisie)",
    channel: "Canal",
    escalationTone: "Ton",
    templateKey: "Clé de template",
    toneNeutral: "Neutre",
    toneFirm: "Ferme",
    toneFormal: "Formel",
    addLateFee: "Ajouter des frais de rappel",
    lateFeeType: "Type de frais",
    lateFeeFixed: "Forfait",
    lateFeeInterest: "Intérêt moratoire",
    lateFeeBoth: "Forfait + intérêt",
    lateFeeLabel: "Libellé sur la facture",
    fixedAmount: "Montant forfaitaire",
    annualRate: "Taux annuel (%)",
    interestBase: "Base de calcul",
    basePrincipal: "Créance principale",
    baseCurrent: "Montant courant",
    dunningPolicy: "Politique de relance",
    noDunning: "Pas de relance",
    dunningPolicyHint: "Choisissez la politique de relance pour ce document",
    dunningConfigured: "Configurée",
    dunningRelances: "Relances",
    dunningActive: "Actives",
    dunningSuspended: "Suspendues",
    dunningStopped: "Arrêtées",
    dunningUntil: "jusqu'au",
    lateFee: "Frais",
    noDunningSent: "Aucune relance envoyée pour l'instant.",
    suspendDunning: "Suspendre les relances ?",
    resumeDunning: "Reprendre",
    stopDunning: "Arrêter définitivement les relances ?",
    yesStop: "Oui, arrêter",
    dunningWillPause: "Les relances automatiques seront mises en pause pour cette facture.",
    dunningStopIrreversible: "Cette facture ne sera plus jamais relancée automatiquement.",
    dunningResumed: "Relances reprises",

    // Subscription banner
    subscriptionTrialBanner: "Votre essai gratuit se termine le {date} ({days} jours restants)",
    subscriptionPastDueBanner: "Votre facture est impayée. Veuillez régulariser avant le {date} pour éviter une interruption de service",
    subscriptionExpiredBanner: "Votre abonnement a expiré. L'accès est en lecture seule. Veuillez renouveler pour restaurer l'accès complet",
    subscriptionCancelledBanner: "Votre abonnement prend fin le {date}",
    subscriptionDaysRemaining: "{days} jours restants",
    subscriptionPayNow: "Payer maintenant",
    subscriptionChoosePlan: "Choisir une offre",

    // Subscription & plan labels
    subscription: "Abonnement",
    featureNotIncluded: "Non inclus dans votre offre actuelle",
    featureRequiresPlan: "Disponible à partir de l'offre {plan}",
    featureRequiresActiveSubscription: "Un abonnement actif est requis",
    featureViewOffers: "Voir les offres",
    featureRegularize: "Régulariser l'abonnement",
    featureContactAdmin: "Contactez votre administrateur pour changer d'offre",

    // Subscription management (F2)
    subscriptionMySubscription: "Mon abonnement",
    subscriptionOffers: "Offres & tarifs",
    subscriptionCurrentPlan: "Offre actuelle",
    subscriptionFreePlan: "Gratuit",
    subscriptionBillingCycle: "Périodicité",
    subscriptionNextRenewal: "Prochain renouvellement",
    subscriptionTrialEndsOn: "L'essai se termine le {date}",
    subscriptionTrialDaysLeft: "{days} jours restants dans votre essai",
    subscriptionPendingChange: "Changement en attente",
    subscriptionPendingChangeDetail: "Vous passerez à {plan} le {date}",
    subscriptionCancelPendingChange: "Annuler ce changement",
    subscriptionPendingChangeCancelled: "Changement en attente annulé",
    subscriptionCancelPendingConfirmTitle: "Annuler le changement de plan ?",
    subscriptionCancelPendingConfirmText: "Votre abonnement restera sur le plan {currentPlan}. Le passage au plan {pendingPlan} n'aura pas lieu.",
    subscriptionQuotas: "Utilisation & quotas",
    subscriptionQuotaUsage: "{current} / {limit}",
    subscriptionUnlimited: "Illimité",
    subscriptionChangePlan: "Changer d'offre",
    subscriptionChooseMyOffer: "Choisir mon offre",
    subscriptionPayMyInvoice: "Payer ma facture",
    subscriptionAnnualSavingsHint: "Économisez {percent} % avec la facturation annuelle",
    subscriptionCancelSubscription: "Résilier l'abonnement",
    subscriptionReactivate: "Réactiver",
    subscriptionCancelConfirmTitle: "Résilier votre abonnement ?",
    subscriptionCancelConfirmText: "Vous conservez l'accès jusqu'à la fin de la période en cours. Ensuite, votre abonnement ne sera pas renouvelé.",
    subscriptionCancelledSuccess: "Votre abonnement a été résilié",
    subscriptionReactivatedSuccess: "Votre abonnement a été réactivé",
    subscriptionUpgrade: "Passer à l'offre supérieure",
    subscriptionDowngrade: "Passer à l'offre inférieure",
    subscriptionUpgradeConfirmTitle: "Passer à {plan} ?",
    subscriptionUpgradeConfirmText: "Ce changement prend effet immédiatement. Vous serez facturé au prorata.",
    subscriptionDowngradeConfirmTitle: "Passer à {plan} ?",
    subscriptionDowngradeConfirmText: "Votre offre passera à {plan} le {date}. Vous gardez vos fonctions actuelles jusque-là.",
    subscriptionChangeSuccess: "Votre offre a été mise à jour",
    subscriptionEffectImmediate: "Effet immédiat",
    subscriptionEffectAtDate: "Prend effet le {date}",
    subscriptionYouWillBeCharged: "Montant à facturer : {amount}",
    subscriptionProrataNotice: "Vous serez facturé au prorata",
    subscriptionCompareOffers: "Comparer les offres",
    subscriptionYourCurrentPlan: "Votre offre",
    subscriptionSelectPlan: "Sélectionner",
    subscriptionIncluded: "Inclus",
    subscriptionOptionalAddon: "En option",
    subscriptionNotIncluded: "Non inclus",
    subscriptionCatalogUnavailable: "Les offres sont momentanément indisponibles. Veuillez réessayer plus tard.",
    subscriptionNoPricingForCycle: "Non disponible pour cette périodicité",
    subscriptionNoPlan: "Aucune offre active",
    subscriptionStatusActive: "Actif",
    subscriptionStatusTrial: "Essai",
    subscriptionStatusPastDue: "Impayé",
    subscriptionStatusExpired: "Expiré",
    subscriptionStatusCancelled: "Résilié",
    subscriptionPerMonth: "/mois",
    subscriptionPerYear: "/an",
    subscriptionEquivPerMonth: "/mois",
    subscriptionBilledPerYear: "Facturé {amount}/an",
    subscriptionSavingsPercent: "Économisez {percent} %",
    featureComingSoon: "Bientôt disponible",

    // Upgrade modal (F6)
    subscriptionUpgradePlan: "Changer d'offre",
    subscriptionWhatsInPlan: "Contenu de l'offre {plan}",
    subscriptionRecommended: "Recommandé",
    subscriptionFeatureRequiresUpgrade: "La fonctionnalité {feature} nécessite une offre supérieure.",
    payrollAccessDeniedPlanRequired: "Le module salaires n'est pas inclus dans votre offre actuelle. Passez à une offre supérieure pour y accéder.",
    subscriptionModalTitleChoose: "Choisissez votre offre",
    subscriptionModalTitleChange: "Changer d'offre",
    subscriptionSubscribeAction: "S'abonner",
    subscriptionSwitchTo: "Passer à {plan}",
    subscriptionDowngradeTo: "Rétrograder vers {plan}",
    subscriptionFeaturesAdded: "Fonctionnalités incluses",
    subscriptionFeaturesRemoved: "Fonctionnalités non incluses",
    subscriptionSeeAllFeatures: "Voir toutes les fonctionnalités",
    subscriptionHideFeatures: "Masquer les fonctionnalités",

    // First-choice flow (Lot 4)
    subscriptionChooseTitle: "Choisissez votre offre",
    subscriptionChooseSubtitle: "Sélectionnez une offre et des options pour commencer.",
    subscriptionChooseConfirmTitle: "Confirmez votre choix",
    subscriptionChooseConfirmText: "Vous allez souscrire à l'offre {plan} ({cycle}).",
    subscriptionChooseSuccess: "Votre offre a été activée",
    subscriptionChooseWithAddons: "avec {count} option(s)",
    subscriptionPriceSummary: "Récapitulatif du prix",
    subscriptionPlanPrice: "Offre ({plan})",
    subscriptionAddonsTotal: "Options",
    subscriptionSubtotalHT: "Sous-total HT",
    subscriptionVatRate: "TVA ({rate} %)",
    subscriptionTotalTTC: "Total TTC",
    subscriptionVatOnInvoiceNote: "Tous les prix sont indiqués HT. La TVA figurera sur votre facture.",
    subscriptionConfirmChoice: "Confirmer et souscrire",
    subscriptionWizardStepPlan: "Offre",
    subscriptionWizardStepAddons: "Options",
    subscriptionWizardStepSummary: "Récapitulatif",
    subscriptionWizardNext: "Suivant",
    subscriptionWizardBack: "Retour",
    subscriptionWizardConfirmAndPay: "Confirmer et payer",
    subscriptionAddonsLoading: "Chargement des options disponibles…",
    subscriptionAddonsLoadError: "Impossible de charger les options. Veuillez réessayer.",
    subscriptionAddonsIncompatibleRemoved: "Certaines options ont été retirées car elles ne sont pas compatibles avec l'offre sélectionnée.",
    subscriptionTotalHT: "Total HT",
    subscriptionChangeTitle: "Changer d'offre",
    subscriptionChangeSubtitle: "Sélectionnez une nouvelle offre et des options.",
    subscriptionWizardConfirmChange: "Confirmer le changement",
    subscriptionConfirmedWaiting: "Votre abonnement est confirm\u00e9. Nous pr\u00e9parons votre facture\u2026",
    subscriptionInvoiceReady: "Votre facture est pr\u00eate.",
    subscriptionTimeoutMessage: "Votre abonnement est confirm\u00e9. Votre facture sera disponible dans quelques instants sur l\u2019\u00e9cran d\u2019abonnement.",
    subscriptionDownloadingPdf: "T\u00e9l\u00e9chargement\u2026",
    subscriptionPlanDenied: "Cette offre n'est pas disponible pour votre compte.",
    subscriptionAddonBlocksChange: "Certaines options sélectionnées sont incompatibles avec cette offre. Veuillez les désélectionner.",
    subscriptionSelectAddons: "Options facultatives",
    subscriptionNoAddonsSelected: "Aucune option sélectionnée",
    subscriptionInvoiceNotice: "Une facture vous sera adressée {days} jours avant le début de l'abonnement.",
    subscriptionTrialUnchanged: "Votre essai gratuit reste actif jusqu'au {date}.",
    subscriptionPaymentFlexible: "Chaque facture pourra être réglée par QR-facture ou par carte — vous choisissez à chaque échéance.",
    subscriptionTermsLink: "Conditions générales de vente",
    subscriptionRenewalNoticeMonthly: "Votre abonnement sera renouvelé automatiquement chaque mois au tarif de {amount} HT, sauf résiliation préalable.",
    subscriptionRenewalNoticeYearly: "Votre abonnement sera renouvelé automatiquement chaque année au tarif de {amount} HT, sauf résiliation préalable.",
    subscriptionCancellationNotice: "Vous pouvez résilier votre abonnement à tout moment depuis cette page. La résiliation prend effet à la fin de la période en cours — vous conservez l'accès jusqu'à cette date.",

    // Trial-aware billing disclosures (Lot 3)
    subscriptionInvoiceIssuedNow: "Votre facture est émise dès maintenant, à régler avant le {date}.",
    subscriptionTrialUpgradeNotice: "Nouvelle offre dès maintenant. Facture de la différence de {amount} HT, à régler avant le {date}.",
    subscriptionTrialUpgradeOperatorNotice: "Votre première facture sera établie au tarif de {plan}.",
    subscriptionTrialDowngradeNotice: "{plan} s'appliquera à partir du {date}. Votre première période reste en {currentPlan}.",
    subscriptionCancelResiliation: "Annuler la résiliation",
    subscriptionCancelResiliationConfirmText: "Votre abonnement continue et la facturation reprend normalement.",
    subscriptionErrorNothingToUndo: "Il n'y a pas de résiliation en cours à annuler.",
    subscriptionCancelConfirmButton: "Oui, résilier",
    subscriptionKeepSubscription: "Garder mon abonnement",
    subscriptionEndingNotice: "Votre abonnement prendra fin le {date}.",
    subscriptionAddonOnlyTrialNotice: "Les options sélectionnées sont offertes jusqu'à la fin de votre essai le {date}. Aucune facture ne sera émise maintenant.",
    subscriptionAddonOnlyProrataNotice: "Une facture au prorata sera générée pour les options sélectionnées.",
    subscriptionAddonOnlySuccess: "Vos options ont été activées avec succès.",
    subscriptionErrorPlanChoiceRequired: "Veuillez d'abord choisir une offre avant de la modifier.",

    // Add-ons (F7 part C)
    addonSectionTitle: "Options",
    addonAvailable: "Disponible",
    addonActive: "Actif",
    addonPendingCancellation: "Actif — résiliation en fin de période",
    addonActivate: "Activer",
    addonDeactivate: "Désactiver",
    addonActivateConfirmTitle: "Activer {name} ?",
    addonActivateConfirmText: "Cette option coûte {price} et la facturation est immédiate. Une facture au prorata sera générée tout de suite. Ce n'est pas un essai gratuit.",
    addonActivateConfirmTextTrial: "Cette option est offerte jusqu'à la fin de votre essai le {date}. Aucune facture ne sera émise maintenant. Après l'essai, elle sera facturée {price} avec votre plan.",
    addonActivateConfirmButton: "Activer maintenant",
    addonActivatedSuccess: "{name} est maintenant actif",
    addonActivatedInvoiceNotice: "La fonctionnalité est disponible immédiatement. Une facture au prorata suivra sous peu.",
    addonActivatedInvoiceNoticeTrial: "La fonctionnalité est disponible immédiatement, sans frais jusqu'au {date}. La facturation commencera avec votre plan.",
    addonDeactivateConfirmTitle: "Désactiver {name} ?",
    addonDeactivateConfirmText: "L'option restera active jusqu'à la fin de la période en cours ({date}). Aucun remboursement ne sera effectué — la facturation s'arrête en fin de période.",
    addonDeactivateConfirmButton: "Désactiver en fin de période",
    addonDeactivatedSuccess: "{name} sera désactivé en fin de période",
    addonAlreadyActive: "Cette option est déjà active",
    addonIncompatible: "Cette option n'est pas compatible avec votre offre actuelle",
    addonNoPermission: "Vous n'avez pas la permission de gérer les options. Contactez votre administrateur.",
    addonActiveUntil: "Actif jusqu'au {date}",
    addonBillingCycleMonthly: "par mois",
    addonBillingCycleYearly: "par an",
    addonBillingCycleOneTime: "unique",
    addonNoneAvailable: "Aucune option disponible pour votre offre actuelle.",
    addonManageAddons: "Gérer les options",

    // Gated nav items — disabled tab tooltips
    navFeatureRequiresUpgrade: "Inclus à partir d'une offre supérieure",
    navFeatureAvailableAsAddon: "Disponible en option",

    // Billing — invoices & payments (F3)
    billingInvoices: "Factures",
    billingInvoiceNumber: "Numéro",
    billingInvoiceDate: "Date",
    billingInvoiceDueDate: "Échéance",
    billingInvoiceAmount: "Montant",
    billingInvoiceStatus: "Statut",
    billingInvoiceStatusOpen: "Ouverte",
    billingInvoiceStatusPaid: "Payée",
    billingInvoiceStatusVoid: "Annulée",
    billingInvoiceStatusDraft: "Brouillon",
    billingInvoiceStatusUncollectible: "Irrécouvrable",
    billingInvoiceOverdue: "En retard",
    billingPay: "Payer",
    billingDownloadPdf: "Télécharger le PDF",
    billingPaymentPending: "Paiement en cours…",
    billingPayments: "Paiements",
    billingPaymentDate: "Date",
    billingPaymentAmount: "Montant",
    billingPaymentMethod: "Moyen",
    billingPaymentResult: "Résultat",
    billingPaymentSucceeded: "Réussi",
    billingPaymentFailed: "Échoué",
    billingPaymentRefunded: "Remboursé",
    billingPaymentFailureReason: "Motif",
    billingPaymentRetry: "Réessayer",
    billingPaymentMethods: "Moyens de paiement",
    billingCardBrand: "Carte",
    billingCardEnding: "se terminant par {last4}",
    billingCardExpires: "Expire {month}/{year}",
    billingCardExpiringSoon: "Expire bientôt",
    billingCardDefault: "Par défaut",
    billingAddPaymentMethod: "Ajouter un moyen de paiement",
    billingDeletePaymentMethod: "Supprimer",
    billingDeleteMethodConfirmTitle: "Supprimer ce moyen de paiement ?",
    billingDeleteMethodConfirmText: "Ce moyen de paiement sera définitivement supprimé.",
    billingDeleteDefaultMethodWarning: "C'est votre moyen de paiement par défaut et le recouvrement automatique est activé. Le supprimer sans en ajouter un autre fera échouer le prochain prélèvement.",
    billingMethodDeleted: "Moyen de paiement supprimé",
    billingNoInvoices: "Aucune facture pour le moment",
    billingNoPayments: "Aucun paiement pour le moment",
    billingNoPaymentMethods: "Aucun moyen de paiement enregistré",
    billingUnavailable: "Les informations de facturation sont momentanément indisponibles. Veuillez réessayer plus tard.",
    billingInvoiceDetail: "Détail de la facture",
    billingRelatedInvoice: "Facture",
    paymentTitle: "Paiement",
    paymentCompany: "Entreprise",
    paymentInvoiceNumber: "Facture",
    paymentAmount: "Montant",
    paymentDueDate: "Date d'échéance",
    paymentExpiry: "Valable jusqu'au",
    paymentPayNow: "Payer maintenant",
    paymentRedirecting: "Redirection vers le prestataire de paiement...",
    paymentLinkInvalid: "Ce lien de paiement n'est plus valide.",
    paymentLinkInvalidHint: "Veuillez nous contacter si vous pensez qu'il s'agit d'une erreur.",
    paymentLinkExpiredTitle: "Ce lien de paiement a expiré",
    paymentLinkExpiredDescription: "Ce lien n'est plus valable. Veuillez retourner à vos factures pour en demander un nouveau.",
    paymentLinkExpiredAction: "Aller à mes factures",
    paymentProcessing: "Traitement de votre paiement...",
    paymentProcessingHint: "Veuillez patienter pendant la confirmation de votre paiement.",
    paymentSucceeded: "Paiement réussi",
    paymentSucceededHint: "Votre paiement a été traité. Vous pouvez fermer cette page.",
    paymentPending: "Paiement en cours de traitement",
    paymentPendingHint: "Votre paiement est en cours de traitement. Vous recevrez une confirmation par e-mail sous peu.",
    paymentFailed: "Échec du paiement",
    paymentFailedHint: "Votre paiement n'a pas pu être traité. Veuillez réessayer ou nous contacter.",
    paymentCancelled: "Paiement annulé",
    paymentCancelledHint: "Vous avez annulé le paiement. Aucun montant n'a été débité.",
    paymentStatusUnavailable: "Statut indisponible",
    paymentStatusUnavailableHint: "Nous n'avons pas pu récupérer le statut du paiement. Veuillez vérifier votre e-mail pour confirmation.",
    paymentRetry: "Réessayer le paiement",
    paymentRetryExpired: "Ce lien de paiement a expiré. Veuillez en demander un nouveau depuis vos factures.",
    paymentBackToSubscription: "Retour à mon abonnement",
    paymentRedirectingIn: "Redirection dans {0} s\u2026",
    paymentAmountPaid: "Montant payé",
    paymentSignIn: "Se connecter",
    paymentCheckAgain: "Vérifier à nouveau",
    paymentNothingElseRequired: "Votre facture est réglée. Rien d'autre ne vous est demandé.",
    billingAmountDue: "Montant dû",
    billingAmountDueCount: "{count} factures",
    billingDueDate: "Échéance le {date}",
    billingViewInvoices: "Voir les factures",
    billingPayAmount: "Payer {amount}",
    addonStepTitle: "Ajoutez des options à votre offre",
    addonStepHint: "Ces options sont compatibles avec votre nouvelle offre. Vous pouvez aussi les ajouter plus tard.",
    addonStepSkip: "Passer",
    addonStepDone: "Continuer",
    copy: "Copier",
    copied: "Copié",
    showQrCode: "Afficher le QR code",
    scanToAddMeAsContact: "Scannez ce code depuis l'application mobile pour m'ajouter en contact",
    myDigitalAdminCode: "Mon code Digital Admin",
    uuidTypeMismatch: "Le type de l'UUID ne correspond pas au type de contact (personne/entreprise)",
    uuidNotLinked: "Le contact a ete cree, mais l'UUID fourni ne correspond a aucun utilisateur inscrit",
    chatNoRegisteredContacts: "Aucun contact inscrit",
    chatRegisteredContactsHint: "Vos contacts qui ont un compte Digital Admin apparaissent ici",
    chatMembersUnavailable: "Cette societe n'expose pas ses membres",
    chatSelectContact: "Choisir un contact",
    chatStartNewConversation: "Demarrer une conversation",
    manualEntryMatchesWarning: "Des documents ou paiements correspondent à cette ligne. Préférez le rapprochement depuis la liste des correspondances.",
    viewMatches: "Voir les correspondances",
    directChargeWarning: "Vous enregistrez une charge directe. Si ce mouvement paie une facture fournisseur existante, utilisez le rapprochement pour ne pas compter la charge deux fois.",
    directRevenueWarning: "Vous enregistrez un produit direct. Si ce mouvement encaisse une facture client existante, utilisez le rapprochement pour ne pas compter le produit deux fois.",

    // Assets (rental inventory)
    assets: "Biens",
    asset: "Bien",
    createAsset: "Créer un bien",
    editAsset: "Modifier le bien",
    listAssets: "Liste des biens",
    viewAsset: "Voir le bien",
    assetName: "Nom du bien",
    assetCode: "Code",
    assetDescription: "Description",
    defaultDepositAmount: "Caution par défaut",
    acquisitionValue: "Valeur d'acquisition",
    acquisitionDate: "Date d'acquisition",
    isDepreciable: "Amortissable",
    residualValue: "Valeur résiduelle",
    depreciationYears: "Durée d'amortissement (années)",
    depreciationSection: "Amortissement",
    assetStatusAvailable: "Disponible",
    assetStatusRented: "Loué",
    assetStatusOutOfService: "Hors service",
    currentTenant: "Locataire actuel",
    rentedSince: "Loué depuis",
    rentedUntil: "Loué jusqu'au",
    searchAsset: "Rechercher un bien",
    youWantToDeleteTheAsset: "Voulez-vous supprimer ce bien ?",
    assetDeletedSuccess: "Bien supprimé",
    assetCreatedSuccess: "Bien créé",
    assetUpdatedSuccess: "Bien mis à jour",
    assetStatusManagedByRental: "Le statut est géré par les événements de location",
    noAssetsFound: "Aucun bien trouvé",
    rentAsset: "Louer",
    rentThisAsset: "Louer ce bien",
    tenant: "Locataire",
    rentalCadence: "Fréquence de facturation",
    rentalStart: "Date de début",
    rentalEnd: "Date de fin",
    rentalDepositAmount: "Caution",
    confirmRental: "Confirmer la location",
    rentalCreatedSuccess: "Contrat de location créé",
    cadenceMonthly: "Mensuel",
    cadenceQuarterly: "Trimestriel",
    cadenceAnnual: "Annuel",
    cadenceDay: "Jour",
    cadenceWeek: "Semaine",
    cadenceMonth: "Mois",
    cadenceQuarter: "Trimestre",
    cadenceYear: "Annee",
    rentalOptions: "Formules de location",
    addRentalOption: "Ajouter une formule",
    selectService: "Choisir un service",
    rentalOption: "Formule de location",
    selectRentalOption: "Choisir une formule",
    noRentalOptionConfigured: "Ce bien n'a pas de formule de location configuree.",
    noRentalOption: "Aucune formule",

    // Security deposit (caution)
    securityDeposit: "Caution",
    depositAmount: "Montant de la caution",
    depositStatus: "Statut de la caution",
    depositNone: "Aucune",
    depositPending: "En attente",
    depositReceived: "Reçue",
    depositPartiallyRetained: "Partiellement retenue",
    depositReturned: "Restituée",
    receiveDeposit: "Enregistrer la réception",
    returnDeposit: "Restituer la caution",
    retainedAmount: "Montant retenu",
    returnedAmount: "Montant restitué",
    retainedAmountHint: "Montant retenu en cas de dommage",
    amountToReturn: "Montant à restituer",
    depositReceivedSuccess: "Réception de la caution enregistrée",
    depositReturnedSuccess: "Caution restituée",
    receivedAt: "Reçue le",
    returnedAt: "Restituée le",
    depositMethod: "Méthode de paiement",
    depositNote: "Remarque",

    // Expense reports
    expenseReports: "Notes de frais",
    expenseReport: "Note de frais",
    expenseReportNumber: "N° de note",
    listExpenseReports: "Liste des notes de frais",
    createExpenseReport: "Créer une note de frais",
    editExpenseReport: "Modifier la note de frais",
    viewExpenseReport: "Voir la note de frais",
    updateExpenseReport: "Mettre à jour la note de frais",
    submitted: "Soumise",
    validated: "Validée",
    submitExpenseReport: "Soumettre",
    rejectExpenseReport: "Renvoyer pour correction",
    validateExpenseReport: "Valider la note de frais",
    rejectionReason: "Motif du refus",
    rejectionReasonPlaceholder: "Saisissez le motif du refus...",
    rejectionReasonRequired: "Un motif de refus est obligatoire",
    rejectedReason: "Motif du refus",
    reimburse: "Rembourser",
    createReimbursement: "Créer un remboursement",
    createNewReimbursementForExpenseReport: "Créer un nouveau remboursement pour la note de frais",
    employee: "Employé",
    merchant: "Commerçant",
    expenseDate: "Date de la dépense",
    youWantToDeleteThisExpenseReport: "Voulez-vous supprimer cette note de frais ?",
    processOfCreatingANewExpenseReportCompleted: "Processus de création d'une nouvelle note de frais terminé.",
    ifYouWantToSaveTheNewExpenseReport: "si vous souhaitez enregistrer la nouvelle note de frais.",
    processOfUpdatingAnExpenseReportCompleted: "Processus de mise à jour d'une note de frais terminé.",
    thisExpenseReportHasNoPayments: "Cette note de frais n'a aucun remboursement.",
    youWantToSubmitThisExpenseReport: "Voulez-vous soumettre cette note de frais ?",
    expenseReportSubmittedSuccessfully: "Note de frais soumise avec succès.",
    youWantToValidateThisExpenseReport: "Voulez-vous valider cette note de frais ?",
    youWantToInvalidateThisExpenseReport: "Si vous invalidez cette note de frais, les écritures comptables associées seront supprimées.",
    iban: "IBAN",
    receipt: "Justificatif",
    attachReceipt: "Joindre un justificatif",
    removeReceipt: "Supprimer le justificatif",
    expenseLineDetails: "Détails de la ligne de dépense",
    newExpenseReport: "Nouvelle note de frais",
    descriptionCreateExpenseReport: "Veuillez saisir les informations suivantes, elles sont nécessaires pour créer une nouvelle note de frais.",
    pleaseModifyFieldsFromExpenseReport: "Modifiez, ajoutez et/ou supprimez les champs que vous souhaitez de la note de frais.",
    selectAnEmployee: "Sélectionner un employé",
    beforeCreatingExpenseReport: "Avant de créer la note de frais",
    wouldYouLikeUploadPdfFilesToExpenseReport: "Souhaitez-vous télécharger des fichiers PDF pour la nouvelle note de frais ?",
    whenYouUploadPdfFilesTheyArePlacedAsExpenseReportLines: "Lorsque vous téléchargez des fichiers PDF, ils sont placés comme justificatifs sur chaque ligne de dépense du formulaire de création.",
    expenseBelongsToExpenseReport: "Cette dépense appartient à la note de frais",
    expenseManagedFromReport: "Elle se modifie et se valide depuis la note de frais.",

    // Write-off (solder en perte)
    chargedOff: "Soldée en perte",
    writeOff: "Solder en perte",
    writeOffInvoice: "Solder la facture en perte",
    writeOffAmount: "Montant à solder",
    writeOffDate: "Date du solde",
    writeOffLossAccount: "Compte de perte",
    writeOffReason: "Motif",
    writeOffReasonRequired: "Un motif est requis",
    writeOffConfirmMessage: "Cette facture sera soldée en perte de",
    writeOffVatCorrectionMessage: "La TVA de {amount} sera corrigée (chiffre 235).",
    writeOffSuccess: "Facture soldée en perte avec succès",
    writeOffCancelConfirm: "Voulez-vous annuler ce solde en perte ?",
    writeOffCancelSuccess: "Solde en perte annulé avec succès",
    writeOffs: "Soldes en perte",
    writeOffAmountExceedsDebt: "Le montant dépasse la dette restante",
    invoiceAlreadyChargedOff: "Cette facture est déjà soldée en perte",

    // Expense access (employee)
    expenseAccess: "Accès aux notes de frais",
    expenseAccessAuto: "Automatique (selon le statut)",
    expenseAccessForcedOn: "Toujours autorisé",
    expenseAccessForcedOff: "Jamais autorisé",
    expenseAccessHelp: "Automatique : autorisé si l'employé est en cours d'emploi (brouillon ou actif). Toujours/Jamais : forcent l'accès quel que soit le statut.",
  },
};
